[
  {
    "id": 380,
    "uuid": "167ff1b8-1804-46a9-bba4-7ef3e27183e3",
    "hitokoto": "流浪去吧，总会在世界的一角找到愿意懂你的人。",
    "type": "f",
    "from": "几米",
    "from_who": null,
    "creator": "xuduoyu17",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949600",
    "length": 22
  },
  {
    "id": 381,
    "uuid": "2c9a64ff-25c0-4f5a-8430-3377d00077cd",
    "hitokoto": "我们在年少时并不知道，有些乐章一旦开始，唱的就是曲终人散。",
    "type": "f",
    "from": "九ちのセカィ",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949600",
    "length": 29
  },
  {
    "id": 382,
    "uuid": "afdbb84d-bed4-4e9a-8e95-51b6b0fe13d4",
    "hitokoto": "故乡的云。上古的玉。随手的诗。十九岁的你。",
    "type": "f",
    "from": "可遇不可求的事",
    "from_who": null,
    "creator": "無い",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949601",
    "length": 21
  },
  {
    "id": 383,
    "uuid": "994ed2d8-06c6-4bf9-8f2b-b80876616824",
    "hitokoto": "我敬你是条汉子！",
    "type": "f",
    "from": "论如何回答女友问题“你为什么对我这么好”",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949601",
    "length": 8
  },
  {
    "id": 384,
    "uuid": "369d4d8a-1749-473d-9a07-c1001175e913",
    "hitokoto": "记得当时年纪小，你爱卖萌我爱笑。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "ssc1355",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949601",
    "length": 16
  },
  {
    "id": 385,
    "uuid": "01220135-ef58-4844-b10a-57d5fad2cf4b",
    "hitokoto": "生活就像愤怒的小鸟，失败后总有几只猪在笑。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "yudezhuixun",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949601",
    "length": 21
  },
  {
    "id": 386,
    "uuid": "64734ca9-1f34-43b4-b4ae-22ae3a7ba2c4",
    "hitokoto": "我们擦身而过，是为了相识或者遗忘。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "冰井迷音",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949601",
    "length": 17
  },
  {
    "id": 387,
    "uuid": "576eefe4-7206-46ff-b2e8-88c3dedb5dd3",
    "hitokoto": "给我一个电话亭，我要拯救地球。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "高旺",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949601",
    "length": 15
  },
  {
    "id": 388,
    "uuid": "d018d48f-4072-4736-a750-3c4856fb8077",
    "hitokoto": "你若盛开，清风自来。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "初忆",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949601",
    "length": 10
  },
  {
    "id": 389,
    "uuid": "d6094385-4381-450a-9482-e96f4cb46174",
    "hitokoto": "以前高中时，羡慕大学考试只要及格就行；现在大学了，怀念高中考试及不及格都行……",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "lakesiilove",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949602",
    "length": 39
  },
  {
    "id": 390,
    "uuid": "26a01750-fd36-42a8-a751-d37cbabeaed0",
    "hitokoto": "君子可寓意于物，但不可留意于物。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "LastFairy",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949602",
    "length": 16
  },
  {
    "id": 391,
    "uuid": "b0d15a52-3f1e-49fb-9e7a-8f36701d7a76",
    "hitokoto": "风筝的线你随时可以放开，只是别盼望我会回来。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949602",
    "length": 22
  },
  {
    "id": 392,
    "uuid": "108ef3b6-f55c-4144-a28b-8927820df2a0",
    "hitokoto": "那种亲密的人突然陌生，希望完全落空的感觉，就好像喝口凉水居然被烫到。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949602",
    "length": 34
  },
  {
    "id": 394,
    "uuid": "74a383dc-a94b-4f84-b9a9-4c3133a00663",
    "hitokoto": "天空本是一种风景，可是遇见你之后，它变成了一种心情。",
    "type": "f",
    "from": "九ちのセカィ",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949602",
    "length": 26
  },
  {
    "id": 395,
    "uuid": "2e183f0c-f818-4578-8021-47c374fa2e74",
    "hitokoto": "地球只有一个，而欧派有两个。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "mlmtmfz",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949603",
    "length": 14
  },
  {
    "id": 396,
    "uuid": "22daf211-5921-47f6-82cf-771fe518ee73",
    "hitokoto": "成熟不是人的心变老，是泪在打转还能微笑。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949603",
    "length": 20
  },
  {
    "id": 397,
    "uuid": "609c6789-fb47-4d7b-af34-1fcbe609b0dd",
    "hitokoto": "等待，不是为了你能回来，而是找个借口不离开。",
    "type": "f",
    "from": "九ちのセカィ",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949603",
    "length": 22
  },
  {
    "id": 398,
    "uuid": "15f4bd7e-da3a-4f4c-878a-b9d77bd4a040",
    "hitokoto": "最终让你难以忘怀的，并不是某个谁，而是当初为之倾心，不顾一切的自己。",
    "type": "f",
    "from": "九ちのセカィ",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949603",
    "length": 34
  },
  {
    "id": 399,
    "uuid": "4ca539b4-d533-4721-85af-4c54da60b716",
    "hitokoto": "如果分手的恋人还能做朋友，要不从没爱过，要不还在爱着。",
    "type": "f",
    "from": "九ちのセカィ",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949603",
    "length": 27
  },
  {
    "id": 400,
    "uuid": "384a97a9-6084-4b19-9f1d-6f56cb2931bb",
    "hitokoto": "研表究明，汉字的序顺并不定一能影阅响读，比如当你看完这句话后，才发这现里的字全是都乱的。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "吾乃外星人",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949603",
    "length": 44
  },
  {
    "id": 401,
    "uuid": "417baaf9-c1a5-498f-b2c3-ac95f76af920",
    "hitokoto": "活着就是为了改变世界。",
    "type": "f",
    "from": "Apple",
    "from_who": null,
    "creator": "叉叉",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949604",
    "length": 11
  },
  {
    "id": 402,
    "uuid": "e29245d5-ebff-4a1d-b37b-f20d88c2f6e5",
    "hitokoto": "H什么的最讨厌了！",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "恶魔？天使",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949604",
    "length": 9
  },
  {
    "id": 403,
    "uuid": "2d3b0e40-4a87-496c-a7cd-5a3743428a23",
    "hitokoto": "放弃也是需要勇气的。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "世风",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949605",
    "length": 10
  },
  {
    "id": 405,
    "uuid": "ec090f91-8294-44fa-9f1e-3cb8e89a6d3f",
    "hitokoto": "胸不平何以平天下，乳不巨何以聚人心。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "天使の心跳",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949605",
    "length": 18
  },
  {
    "id": 406,
    "uuid": "cd22fb8f-55a1-4b4e-b696-262981a3dddc",
    "hitokoto": "忘记一个人，并非不再想起，而是偶尔想起，心中却不再有波澜。",
    "type": "f",
    "from": "九ちのセカィ",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949605",
    "length": 29
  },
  {
    "id": 407,
    "uuid": "75f52946-d8a8-4a5f-acfa-923117874af0",
    "hitokoto": "即使无法掌握未来，也请不要忘了明天。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "leozx",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949605",
    "length": 18
  },
  {
    "id": 408,
    "uuid": "06f60a39-f899-4f2b-b11e-a3411e79a844",
    "hitokoto": "不忘初心，方得始终。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Nitro",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949606",
    "length": 10
  },
  {
    "id": 409,
    "uuid": "7f9908c1-02dd-4c99-80da-fb4d328065a6",
    "hitokoto": "你制定的计划是.txt还是.exe?",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "LvionX",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949606",
    "length": 18
  },
  {
    "id": 410,
    "uuid": "b5eb69b1-b565-46b4-b1b9-13e75ca70ab2",
    "hitokoto": "心之所愿，无所不成。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "漠伦",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949606",
    "length": 10
  },
  {
    "id": 411,
    "uuid": "de3678e6-ca91-4d06-bee0-904fe4762060",
    "hitokoto": "无论是丢下还是被丢下，都是一样痛苦的。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "锡了个纸",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949606",
    "length": 19
  },
  {
    "id": 412,
    "uuid": "65cfb785-f85b-4752-9218-5c7a1221b40b",
    "hitokoto": "不约，不约，叔叔我们不约~",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "月球猫",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949607",
    "length": 13
  },
  {
    "id": 413,
    "uuid": "ea1f5517-6d4c-492e-a139-ceec3bb17332",
    "hitokoto": "既然认准这条路，何必去打听要走多久。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "zerokey",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949607",
    "length": 18
  },
  {
    "id": 414,
    "uuid": "694c1696-daf8-485e-85f2-0be0255bfcd1",
    "hitokoto": "有些人，一旦遇见，便一眼万年；有些心动，一旦开始，便覆水难收。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "zerokey",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949607",
    "length": 31
  },
  {
    "id": 415,
    "uuid": "18a1f1ee-20c1-4309-9041-4ec7429ecffa",
    "hitokoto": "一定是红线下得太乱，才不小心把我和你绑在一起了……却没系稳。",
    "type": "f",
    "from": "_好多虫漫画",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949607",
    "length": 30
  },
  {
    "id": 416,
    "uuid": "e76de41d-d875-431d-8d1c-01b11e678c05",
    "hitokoto": "不敢正视你的眼睛，是怕我每一个眼神都在告白。",
    "type": "f",
    "from": "九ちのセカィ",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949607",
    "length": 22
  },
  {
    "id": 417,
    "uuid": "870857f7-663f-48aa-87aa-65bf26cd6907",
    "hitokoto": "别人说的记在脑袋里，而自己的，则放在心里。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949608",
    "length": 21
  },
  {
    "id": 418,
    "uuid": "9fd5c5ff-53dd-4d98-88d4-581849a8f2a9",
    "hitokoto": "想你想到手都断了…",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949609",
    "length": 9
  },
  {
    "id": 419,
    "uuid": "0eea1f47-b826-4993-b2c3-e254f531e6ba",
    "hitokoto": "没有回忆就去创造回忆，没有道路就去开辟道路。",
    "type": "f",
    "from": "平安夜的噩梦",
    "from_who": null,
    "creator": "沙渺",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949609",
    "length": 22
  },
  {
    "id": 420,
    "uuid": "09a8eca7-e241-40c9-9225-f80369bf6902",
    "hitokoto": "没有什么过不去，只是再也回不去。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "zerokey",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949610",
    "length": 16
  },
  {
    "id": 421,
    "uuid": "0158cf66-2605-4409-892b-a999287b340f",
    "hitokoto": "记性太好，有时候是一种负担。容易忘记往事的人，是幸福的。",
    "type": "f",
    "from": "九ちのセカィ",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949610",
    "length": 28
  },
  {
    "id": 422,
    "uuid": "e8139270-83b6-4b04-b159-c046b96a8d0d",
    "hitokoto": "低头不是认输，是要看清自己的路；昂头不是骄傲，是要看清自己的天空。",
    "type": "f",
    "from": "科比·布莱恩特",
    "from_who": null,
    "creator": "庄树鹏",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949610",
    "length": 33
  },
  {
    "id": 423,
    "uuid": "3e6db3b0-9b3f-40bf-b652-528c67bfc4ab",
    "hitokoto": "我觉得，我这辈子最灿烂的笑容，大概都奉献给我电脑屏幕了。",
    "type": "f",
    "from": "bilibili",
    "from_who": null,
    "creator": "萌花残",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949610",
    "length": 28
  },
  {
    "id": 424,
    "uuid": "8262f78a-f8ae-495a-bd71-6a0e98cd2f8c",
    "hitokoto": "有一种无奈叫做，你明明是只候鸟，却喜欢上只能给你冬天的人。",
    "type": "f",
    "from": "九ちのセカィ",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949611",
    "length": 29
  },
  {
    "id": 425,
    "uuid": "663210c4-b198-4da9-913b-791831f4a213",
    "hitokoto": "与你的生命等价的东西，这个世界上根本没有。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949612",
    "length": 21
  },
  {
    "id": 426,
    "uuid": "eb2e8532-b24e-4907-94cd-6dc1e0dc3d51",
    "hitokoto": "生活就像超级女生，走到最后的都是纯爷们。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "X",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949613",
    "length": 20
  },
  {
    "id": 427,
    "uuid": "ccfc22ae-ad9f-4936-b990-534f7e7f0ac0",
    "hitokoto": "那天放学的时候人很多。楼道很挤，你的手不小心碰到了我的手背，这是我漫长而又短暂的初恋。",
    "type": "f",
    "from": "九ちのセカィ",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949613",
    "length": 43
  },
  {
    "id": 428,
    "uuid": "80541a4b-0ef6-4a1a-9398-5e54d4562381",
    "hitokoto": "旅行的意义在于找到自己，而非浏览他人。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "zerokey",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949615",
    "length": 19
  },
  {
    "id": 429,
    "uuid": "7043bde9-0a0f-4de8-a65a-6415890c9da0",
    "hitokoto": "我的小伙伴们都惊呆了！",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "矢野加奈",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949615",
    "length": 11
  },
  {
    "id": 430,
    "uuid": "01e388d7-df61-48d0-9e49-95bda454a4cb",
    "hitokoto": "智商是硬伤。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949615",
    "length": 6
  },
  {
    "id": 431,
    "uuid": "12308e01-1a83-4c5f-a71e-53c2a59108ac",
    "hitokoto": "生命太短，一秒钟都不留给让人不快的家伙。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949615",
    "length": 20
  },
  {
    "id": 432,
    "uuid": "1c70b6ca-0545-4737-ba9f-da63460a3423",
    "hitokoto": "XX什么的，最讨厌了！",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "kira0769",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949615",
    "length": 11
  },
  {
    "id": 433,
    "uuid": "671c34ed-2878-4137-b285-5c48d03b9b9b",
    "hitokoto": "请叫我女王大人~",
    "type": "f",
    "from": "十万个冷笑话",
    "from_who": null,
    "creator": "Zhao.small",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949616",
    "length": 8
  },
  {
    "id": 434,
    "uuid": "fb3302c7-d101-441b-96e0-48f3b80ccb5f",
    "hitokoto": "生活中若没有朋友，就像生活中没有阳光一样。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "能美",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949619",
    "length": 21
  },
  {
    "id": 435,
    "uuid": "445c1729-4936-4041-876a-d4a7254f7d9d",
    "hitokoto": "二次元什么的我本来是不感冒的，直到我的膝盖中了一箭。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "智代有爱",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949620",
    "length": 26
  },
  {
    "id": 436,
    "uuid": "1033b1b6-9896-486d-8ac9-8262f0ca4b26",
    "hitokoto": "那么，问题来了…",
    "type": "f",
    "from": "中国山东找蓝翔",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949621",
    "length": 8
  },
  {
    "id": 437,
    "uuid": "9e4981f5-5ae0-44ae-9b76-38b1b420f6e8",
    "hitokoto": "不要祈求生活公平，只需要适应它。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949621",
    "length": 16
  },
  {
    "id": 438,
    "uuid": "68438514-42c0-4de7-a5f6-2d37ebc99986",
    "hitokoto": "空山新雨后，兵长一米六。",
    "type": "f",
    "from": "百度贴吧",
    "from_who": null,
    "creator": "无名的丝塔芙",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949623",
    "length": 12
  },
  {
    "id": 439,
    "uuid": "18dd75a6-70b4-466f-b5a8-cd37ee5d56fe",
    "hitokoto": "过去的事情可以不忘记，但一定要放下。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949624",
    "length": 18
  },
  {
    "id": 440,
    "uuid": "9aa1f9c9-0f8c-4213-ad43-32b4cd562e2b",
    "hitokoto": "孙大圣，快收了神通吧！",
    "type": "f",
    "from": "西游记",
    "from_who": null,
    "creator": "王大囍",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949625",
    "length": 11
  },
  {
    "id": 441,
    "uuid": "005c138a-9027-49ad-aa68-ffa77cb1e840",
    "hitokoto": "黑暗不能驱除黑暗，只有光明可以做到；仇恨不能驱除仇恨，只有爱可以做到。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Avatien",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949626",
    "length": 35
  },
  {
    "id": 442,
    "uuid": "ea07df7b-8dae-45a2-9c49-24bd2eaac664",
    "hitokoto": "在你最冷的时候，有人不顾自己寒冷抱着你，这就是幸福。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "zerokey",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949629",
    "length": 26
  },
  {
    "id": 443,
    "uuid": "968f18d5-2444-4866-a1d0-5c4aaa3bece4",
    "hitokoto": "我和我的小伙伴们都惊呆了！",
    "type": "f",
    "from": "我和我的小伙伴们都惊呆了",
    "from_who": null,
    "creator": "王世强",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949629",
    "length": 13
  },
  {
    "id": 444,
    "uuid": "5d6abf73-e420-4ac0-85bd-e46a500418b7",
    "hitokoto": "患了中二病，等于有了一种信仰。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "三酱",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949630",
    "length": 15
  },
  {
    "id": 445,
    "uuid": "9fda32f5-c54f-4b35-b4b4-4f963e65a403",
    "hitokoto": "（根据相关法律法规，相关内容已被屏蔽。）",
    "type": "f",
    "from": "（根据相关法律法规，相关内容已被屏蔽。）",
    "from_who": null,
    "creator": "地球好闪亮",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949630",
    "length": 20
  },
  {
    "id": 446,
    "uuid": "b5bbc608-ec1f-4f0f-a1e9-e10753226da3",
    "hitokoto": "你还欠我一句对不起，可我不会再说没关系了。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "wxvveboss",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949633",
    "length": 21
  },
  {
    "id": 447,
    "uuid": "9f7fcef3-a251-44dd-831c-752e559a7169",
    "hitokoto": "你才是⑨！你全家都是⑨！",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "琪露诺_⑨",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949635",
    "length": 12
  },
  {
    "id": 449,
    "uuid": "34662c58-8eba-4757-a637-c7c11e9f537e",
    "hitokoto": "喜欢大胸只是本能，喜欢贫乳才是审美。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "ShineAwesome",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949647",
    "length": 18
  },
  {
    "id": 450,
    "uuid": "94586957-0ff7-4eca-852f-226c47f4dbe4",
    "hitokoto": "我年轻，我傲娇。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949651",
    "length": 8
  },
  {
    "id": 451,
    "uuid": "54542d6e-b74c-490a-9311-f544e2a05ff9",
    "hitokoto": "上帝说要有光，于是萝莉就掀起了裙子。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "罗雅",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949653",
    "length": 18
  },
  {
    "id": 452,
    "uuid": "bdc3f730-cdbb-4910-8cb5-0da5d1f394d7",
    "hitokoto": "胸部的大小并没有关系，重要的是存在于那里的温暖。",
    "type": "f",
    "from": "dreamless_milky",
    "from_who": null,
    "creator": "hsk",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949671",
    "length": 24
  },
  {
    "id": 453,
    "uuid": "256c3fe2-5328-44c5-a7b2-cfed198112ef",
    "hitokoto": "找不到路，就自己走一条出来。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "魅影陌客",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949682",
    "length": 14
  },
  {
    "id": 454,
    "uuid": "2f598faf-bc25-4578-8cd3-04e71a9f4cc6",
    "hitokoto": "大地母亲在忽悠着你。",
    "type": "f",
    "from": "魔兽世界",
    "from_who": null,
    "creator": "被流放de蟹子",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949725",
    "length": 10
  },
  {
    "id": 455,
    "uuid": "09863e67-6a63-47f9-8196-4996bea8da4b",
    "hitokoto": "当世界背叛你的那天到来时，我会为你背叛全世界。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "恶魔？天使",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949746",
    "length": 23
  },
  {
    "id": 456,
    "uuid": "b8bc17b5-b94d-407c-a13d-0c34cf721dcd",
    "hitokoto": "有些事情本身我们无法控制，只好控制自己。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949760",
    "length": 20
  },
  {
    "id": 457,
    "uuid": "65e0d6e9-d8d3-4ad9-9e9c-b8750277a5b2",
    "hitokoto": "新闻联播的牛X之处在于就算你一直在换台，也能完整的看完一条新闻。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949790",
    "length": 32
  },
  {
    "id": 458,
    "uuid": "50a227fc-be5f-4652-8c6c-d71632bdf19f",
    "hitokoto": "你最无暇的时光是哪段，你又把它奉献给了谁？",
    "type": "f",
    "from": "B站弹幕",
    "from_who": null,
    "creator": "王晓龙",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949801",
    "length": 21
  },
  {
    "id": 459,
    "uuid": "63b6e184-1d19-4461-8736-effe551a6efb",
    "hitokoto": "是金子一定会发光，是银子一定会花光，是裙子一定会走光，是节操一定要丢光。",
    "type": "f",
    "from": "绝对萌域",
    "from_who": null,
    "creator": "hsk",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949807",
    "length": 36
  },
  {
    "id": 460,
    "uuid": "5f98cc78-af6d-47fb-979e-da2d45d609a2",
    "hitokoto": "最好的感觉，是有人懂你的欲言又止。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "zerokey",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949808",
    "length": 17
  },
  {
    "id": 461,
    "uuid": "eabd4dc9-8351-4ac5-aeaa-dd7e99c93361",
    "hitokoto": "这个城市大得让人到处能一见钟情，却没法重逢。",
    "type": "f",
    "from": "九ちのセカィ",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949863",
    "length": 22
  },
  {
    "id": 462,
    "uuid": "3109b8b6-3b25-4b27-ab97-a972978a0721",
    "hitokoto": "只要一息尚存，就还有希望。",
    "type": "f",
    "from": "格言",
    "from_who": null,
    "creator": "漠伦",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949889",
    "length": 13
  },
  {
    "id": 645,
    "uuid": "0fd68f93-632b-45b9-956b-96d13bec9873",
    "hitokoto": "赢了萌王，输了京介",
    "type": "f",
    "from": "萌王评语",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475082439",
    "length": 9
  },
  {
    "id": 666,
    "uuid": "0dca9bf0-42d9-405f-b9ae-f89b40808d29",
    "hitokoto": "我只是五行缺驱动程序，别说我怠惰。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475617987",
    "length": 17
  },
  {
    "id": 673,
    "uuid": "d0a500e9-f2ef-4262-bb7e-f489adc6915a",
    "hitokoto": "开心就好",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475511806",
    "length": 4
  },
  {
    "id": 707,
    "uuid": "1c336d74-4418-4653-89a7-430db76ad563",
    "hitokoto": "值得获取的东西，就在风险的彼岸。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "″如叶般凋零。",
    "creator_uid": 87,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1477228966",
    "length": 16
  },
  {
    "id": 719,
    "uuid": "ba9c4ac1-cc7b-45cf-bdc5-1441dc1a9de5",
    "hitokoto": "以前高中时，羡慕大学考试只要及格就行；现在大学了，怀念高中考试及不及格都行…",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 38
  },
  {
    "id": 720,
    "uuid": "b86a7a79-9720-492b-9ca4-d0a74ddd3ccc",
    "hitokoto": "我不要你忘记他 , 我只要你记得我",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 17
  },
  {
    "id": 728,
    "uuid": "68d5a6f1-5ecb-4a04-9991-4fe0df535062",
    "hitokoto": "为毛我的眼里常含泪水，因为我老是躺着中枪。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 21
  },
  {
    "id": 736,
    "uuid": "06a2453c-70c9-488c-8fe6-040de22c9bee",
    "hitokoto": "再自信的人都会觉得自己还不够好",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 15
  },
  {
    "id": 746,
    "uuid": "913ae29f-2381-46e8-9301-06b9cbf192bf",
    "hitokoto": "小胖子溜边走~",
    "type": "f",
    "from": "囧的呼唤",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 7
  },
  {
    "id": 788,
    "uuid": "992502d6-7d1b-49d5-bef9-ecd846246798",
    "hitokoto": "宅，是一种生活状态；死宅，是一种人生境界…",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 21
  },
  {
    "id": 792,
    "uuid": "28300930-1165-4b8d-b48c-07858ae394b7",
    "hitokoto": "有一个捉迷藏社团，他们团长现在还没找到。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 20
  },
  {
    "id": 815,
    "uuid": "14c0698f-0306-4d5b-acc4-b7bf4b59c89a",
    "hitokoto": "有家,有爱,有欧派",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 9
  },
  {
    "id": 841,
    "uuid": "56827477-4c50-4eab-bfdc-e21c0f02a59f",
    "hitokoto": "不论生死，好坏，对错；只要载入史册那就代表胜利——历史由胜者书写",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 32
  },
  {
    "id": 868,
    "uuid": "2f046082-44e6-4e23-978d-92f09032c756",
    "hitokoto": "你在我身边也好，在天边也罢，想到世界的角落有一个你，觉得整个世界也变得温柔安定了。",
    "type": "f",
    "from": "琦殿",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 41
  },
  {
    "id": 869,
    "uuid": "ff67e1aa-583e-41e0-9584-0bbcf41fac3c",
    "hitokoto": "只有懦弱和失败者才会四处寻找借口",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 16
  },
  {
    "id": 877,
    "uuid": "43bfa404-4b0e-4588-9c98-7385b554ce12",
    "hitokoto": "被特别在乎的人忽略，会很难过，而更难过的是你还要装作你不在乎。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 31
  },
  {
    "id": 881,
    "uuid": "9e087493-8c0b-4a2a-816b-6f24fcfe3797",
    "hitokoto": "如果你不能给她穿上嫁衣，请停下脱她衣服的手",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 21
  },
  {
    "id": 893,
    "uuid": "a3937652-240f-495a-a231-0a9496f24c0d",
    "hitokoto": "只要你想 你就是在天涯海角 我都会追去 。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 21
  },
  {
    "id": 911,
    "uuid": "93377dff-492f-45c6-ad4c-cad9488ebb67",
    "hitokoto": "难过从来就不能解决任何问题",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 13
  },
  {
    "id": 921,
    "uuid": "7f9a69b6-fc4a-4492-8482-59a9eac35383",
    "hitokoto": "人都有两面，一面天使，一面恶魔。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 16
  },
  {
    "id": 933,
    "uuid": "9477003b-d477-402d-9b2b-8e8999724f08",
    "hitokoto": "人生充斥着谎言,我又岂能独善其身!",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 17
  },
  {
    "id": 937,
    "uuid": "8809dd45-71b7-4446-adcc-402afb9e6540",
    "hitokoto": "我还在原地等你 你却已经忘记来过这里",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 18
  },
  {
    "id": 940,
    "uuid": "7459d0c6-b0f3-404e-9eac-377f3fa09374",
    "hitokoto": "风筝的线你随时可以放开，只是别盼望我会回来",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 21
  },
  {
    "id": 961,
    "uuid": "2352d47f-e625-4d72-8aba-1e992931b2bc",
    "hitokoto": "别把耿直当理由。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Eric",
    "creator_uid": 114,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1479303233",
    "length": 8
  },
  {
    "id": 970,
    "uuid": "e314bad5-7323-458a-8232-5b6d9ea60120",
    "hitokoto": " 像旧时候，像老朋友。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Secret",
    "creator_uid": 133,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1480399619",
    "length": 11
  },
  {
    "id": 973,
    "uuid": "6e7fbdbc-2454-4c62-873c-868e8b7ca89d",
    "hitokoto": "就算路不坦荡也要做自己的太阳。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Secret",
    "creator_uid": 133,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1480399527",
    "length": 15
  },
  {
    "id": 976,
    "uuid": "4f395b36-1c6c-4a2a-b813-3050bc80805d",
    "hitokoto": "如果英雄联盟有停服的那一天，我会用寒冰射手在打一局简单人机，因为从哪里开始就从哪里结束。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "隔壁小轩",
    "creator_uid": 138,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1480818074",
    "length": 44
  },
  {
    "id": 978,
    "uuid": "8e84a508-fbb0-4068-bb48-1277673c4992",
    "hitokoto": "如果你愿意一层一层地剥开我的心，你会发现，里面有二尖瓣、三尖瓣、隔缘肉柱、乳头肌，但就是没有你。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "2021823134",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 48
  },
  {
    "id": 1022,
    "uuid": "23cda901-2e93-4482-a05f-66258fd7a7cb",
    "hitokoto": "父亲永远都是不善于表达他的爱，但他总是会默默地用行动告诉我们，他是有多么的爱我们。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 41
  },
  {
    "id": 1039,
    "uuid": "fd6d29a8-6f72-4004-bfc9-e990ff02c8fb",
    "hitokoto": "不管对什么事情都不能有先入为主的观念。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "1310517752",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 19
  },
  {
    "id": 1045,
    "uuid": "801f2ee8-7c90-41f1-9674-44c035c4a6e3",
    "hitokoto": "人生最重要的是时机，时机对了，凡事都有可能。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 22
  },
  {
    "id": 1055,
    "uuid": "a5583b64-8b33-4571-a16b-d80510d7e859",
    "hitokoto": "我们是如此的担心着未来会发生的事情，因此忘记了慢下来享受现在。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "2394390781",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 31
  },
  {
    "id": 1067,
    "uuid": "13ca5ca5-7f6b-49db-b2f3-ede98461bd12",
    "hitokoto": "你的名字那么普通也就我听到会心头一怔。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 19
  },
  {
    "id": 1073,
    "uuid": "495710f5-89c3-4494-a221-266c63b08b72",
    "hitokoto": "我们嘴里的别人的事听起来就像是自己的事；我们说自己的事的时候，却又在像说一段不相干的故事",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "1277326952",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 44
  },
  {
    "id": 1076,
    "uuid": "eb5fa6bd-5711-4508-9d0d-811af6027990",
    "hitokoto": "你什么时候放下，什么时候就没有烦恼",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 17
  },
  {
    "id": 1092,
    "uuid": "5cec7b54-2a5a-4099-96ae-75f8a6f84688",
    "hitokoto": "梦想不会逃跑，会逃跑的只有人",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 14
  },
  {
    "id": 1106,
    "uuid": "c924895c-a505-49a7-bd22-2ac62834e889",
    "hitokoto": "我房间里堆满了情人节礼物， 我不是高富帅， 我只是个懒惰的快递员。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 33
  },
  {
    "id": 1109,
    "uuid": "dbee4a73-70bc-4984-9240-36664ea244d3",
    "hitokoto": "我们都是好朋友吧，所以你的东西就是我的东西，我的东西还是我的东西。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "505622287",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 33
  },
  {
    "id": 1120,
    "uuid": "8e9cd8d5-bc73-4313-adbf-8698052e19c8",
    "hitokoto": "真正没有资格谈明天的人，是那个不懂得珍惜今天的人",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 24
  },
  {
    "id": 1122,
    "uuid": "aa2f23d4-d54a-4f57-be3f-ed01c58e3811",
    "hitokoto": "不懂装懂，永世饭桶",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 9
  },
  {
    "id": 1123,
    "uuid": "68785029-aedc-4a42-acab-c079b86b56fe",
    "hitokoto": "每一天都是一个全新的开始",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "505622287",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 12
  },
  {
    "id": 1131,
    "uuid": "8d22fead-c4ac-411e-8b14-bb68adc84a2d",
    "hitokoto": "彼岸花开开彼岸,忘川河畔亦忘川。奈何桥头空奈何,三生石上写三生。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Ming丶",
    "creator_uid": 64,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1484628965",
    "length": 32
  },
  {
    "id": 1138,
    "uuid": "ce949ec0-a2c5-4615-a728-afb27b66e1c4",
    "hitokoto": "输了你，赢了这个世界也没意义",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Sωeet、心境",
    "creator_uid": 218,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1485526522",
    "length": 14
  },
  {
    "id": 1142,
    "uuid": "1c1b3200-f8cb-43ca-8714-e0f9fc971830",
    "hitokoto": "与其诅咒黑暗，不如点亮烛光",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "tansinan_1995",
    "creator_uid": 212,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1486654386",
    "length": 13
  },
  {
    "id": 1146,
    "uuid": "52632189-2b8a-4342-8d18-01afccda4460",
    "hitokoto": "你所浪费的今天，是昨天死去的人奢望的明天。你所厌恶的现在，是未来的你回不去的曾经。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "shellingford",
    "creator_uid": 250,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1488006574",
    "length": 41
  },
  {
    "id": 1151,
    "uuid": "c75d955c-9a61-4075-9e92-ccf068363feb",
    "hitokoto": "生命在于折腾，生命不息，折腾不止",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "vclike",
    "creator_uid": 271,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1490370367",
    "length": 16
  },
  {
    "id": 1159,
    "uuid": "90da2563-31fb-4b25-bef6-9fe3bd2c685f",
    "hitokoto": "人的欲望永无止境，就像我一开始，也只是想知道你的名字。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1491399767",
    "length": 27
  },
  {
    "id": 1174,
    "uuid": "3c1c40de-63fe-4037-983e-0f7e5bb6d1c3",
    "hitokoto": "最终让你难以忘怀的，并不是某个谁，而是当初为之倾心，不顾一切的自己。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "1234567",
    "creator_uid": 319,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1493013567",
    "length": 34
  },
  {
    "id": 1177,
    "uuid": "82fd6373-b48c-4e32-8f26-64df84147a81",
    "hitokoto": "我想和你见面，地点你选。森林，沙漠，夜晚依稀的湖畔。草原，大海，清晨薄雾的借口。只是，别在梦里。",
    "type": "f",
    "from": "微博",
    "from_who": null,
    "creator": " 逍遥走走",
    "creator_uid": 337,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1493962260",
    "length": 48
  },
  {
    "id": 1189,
    "uuid": "3bf3318a-5598-430d-bb1a-297240baee82",
    "hitokoto": "忘羡一曲远，曲终人不散",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "yc",
    "creator_uid": 162,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1497700131",
    "length": 11
  },
  {
    "id": 1195,
    "uuid": "4eebdd10-9814-4348-8745-976a8bc484be",
    "hitokoto": "一瓶250ml的吊水，一共是3111滴。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1498718560",
    "length": 20
  },
  {
    "id": 1204,
    "uuid": "e6ffaaf3-928d-4637-825f-b9b64fc3ba88",
    "hitokoto": "无论撒怎样的谎，都无法欺骗自己的心。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "梦语",
    "creator_uid": 438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1499821080",
    "length": 18
  },
  {
    "id": 1205,
    "uuid": "1fbb2890-2dc2-457a-a9cb-96882a109958",
    "hitokoto": "人恰得亏，戏不好看。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "梦语",
    "creator_uid": 438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1499570300",
    "length": 10
  },
  {
    "id": 1236,
    "uuid": "de6f11a8-4581-4ed4-bf43-bee069cde340",
    "hitokoto": "胆小鬼连幸福都害怕，碰到棉花都会受伤",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "zetar",
    "creator_uid": 504,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1502952672",
    "length": 18
  },
  {
    "id": 1272,
    "uuid": "5d0d10eb-7c7a-4638-9756-f17891b7e6a5",
    "hitokoto": "一懒众衫小",
    "type": "f",
    "from": "qq空间",
    "from_who": null,
    "creator": "特卡的帅已是极限",
    "creator_uid": 574,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1507517418",
    "length": 5
  },
  {
    "id": 1274,
    "uuid": "a37352ef-4027-4344-b124-58895bdecd97",
    "hitokoto": "缘，妙不可言",
    "type": "f",
    "from": "阅后即瞎",
    "from_who": null,
    "creator": "無痕",
    "creator_uid": 607,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1508767841",
    "length": 6
  },
  {
    "id": 1304,
    "uuid": "a9ed50e2-a4a4-4566-b2d5-183da28972ff",
    "hitokoto": "今天是一起养狗，以后就一起遛狗，日久生情，狗又生狗。",
    "type": "f",
    "from": "我的少女时代",
    "from_who": null,
    "creator": "知你分子",
    "creator_uid": 830,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512006262",
    "length": 26
  },
  {
    "id": 1305,
    "uuid": "3c1212fa-d991-4bf5-a865-ff665b49a7b7",
    "hitokoto": "生死去留，棚头傀儡。一线断时，落落磊磊。",
    "type": "f",
    "from": "豆瓣网友",
    "from_who": null,
    "creator": "nikazhang",
    "creator_uid": 886,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512535969",
    "length": 20
  },
  {
    "id": 1307,
    "uuid": "449f2d26-bdec-4cd6-8572-ec3d34a79876",
    "hitokoto": "你还有好多未完成的梦，你有什么理由停下脚步",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512524912",
    "length": 21
  },
  {
    "id": 1308,
    "uuid": "c1662da7-3766-43ab-a369-3d492d31340f",
    "hitokoto": "要想飞得高,就该把地平线忘掉",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512524964",
    "length": 14
  },
  {
    "id": 1312,
    "uuid": "90cc7578-58d2-425b-a258-0e3bdbaf484c",
    "hitokoto": "时间是世上最快的一把杀人刀，无论你是万世将种，还是绝世美人，到头来都逃不过这把刀的索命。枯骨荒冢，有谁还记得你生前的模样是丑是美。",
    "type": "f",
    "from": "唐砖",
    "from_who": null,
    "creator": "宝宝洗头爱飘柔",
    "creator_uid": 898,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512718233",
    "length": 65
  },
  {
    "id": 1315,
    "uuid": "8ac3fca5-8d66-4635-a7ab-4c4b9c82d85d",
    "hitokoto": "选择最难的路走暗夜里看成群的星星涌来。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "简夜",
    "creator_uid": 897,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512708852",
    "length": 19
  },
  {
    "id": 1346,
    "uuid": "707c9b81-bf92-44fa-a62c-e071b6946f26",
    "hitokoto": "那些哭着喊着要走的人从来不会真的离开,真的要离开的人会挑一个风和日丽的下午,披一件大衣,不知不觉地消失",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "玉狐",
    "creator_uid": 1000,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1514528150",
    "length": 51
  },
  {
    "id": 1350,
    "uuid": "ee730907-2f19-4c4f-ba8c-d124e9bca6fb",
    "hitokoto": "夜深忽梦少年事，唯梦闲人不梦君。",
    "type": "f",
    "from": "柒",
    "from_who": null,
    "creator": "柒丶",
    "creator_uid": 1015,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1515556699",
    "length": 16
  },
  {
    "id": 1351,
    "uuid": "9c224f35-6d70-49c7-9249-f5104b53ffad",
    "hitokoto": " 葡萄的卷须有一点淡淡的甜味。这东西如果腌成咸菜，大概不难吃。",
    "type": "f",
    "from": "人间草木",
    "from_who": null,
    "creator": "李国宝",
    "creator_uid": 1010,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1514820102",
    "length": 31
  },
  {
    "id": 1355,
    "uuid": "e63ac787-79e4-45ee-856d-545caca03469",
    "hitokoto": "春来暑往，秋去冬藏，又是很多年过去了",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1514863112",
    "length": 18
  },
  {
    "id": 1368,
    "uuid": "423637ba-ba39-4a19-81b4-a067e188002e",
    "hitokoto": "手持两把锟斤拷，口中疾呼烫烫烫。脚踏千朵屯屯屯，笑看万物锘锘锘。",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "sora",
    "creator_uid": 1101,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1517141327",
    "length": 32
  },
  {
    "id": 1382,
    "uuid": "cd032bc0-fd45-45f3-b0c7-4eca68e2b5b4",
    "hitokoto": "承诺常常很像蝴蝶，美丽的盘旋后就不见了。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "斐斐",
    "creator_uid": 209,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1519695843",
    "length": 20
  },
  {
    "id": 1406,
    "uuid": "cfa45284-acb0-4c36-98b2-42d4ebbce0bf",
    "hitokoto": "旅行的意义在于找到自己，而非浏览他人。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "kot32",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1457947896000",
    "length": 19
  },
  {
    "id": 3586,
    "uuid": "fab8e7d3-3136-4133-ad00-4e38828b2fc6",
    "hitokoto": "相传胜利者肯定手持正义,那仅是因为正义可以被胜利者定义",
    "type": "f",
    "from": "天空之边",
    "from_who": null,
    "creator": "aluoblog",
    "creator_uid": 1251,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1521355527",
    "length": 27
  },
  {
    "id": 3593,
    "uuid": "76ed5fc1-a53c-45b4-a29a-62f68a90982f",
    "hitokoto": "所爱隔山海，山海皆可平。可是你不爱我啊，隔了座火焰山还拿不到芭蕉扇。我奋不顾身穿山越岭到了你身旁，你也只会来一句“卧槽你好666啊”",
    "type": "f",
    "from": "网易云音乐热评",
    "from_who": null,
    "creator": "风亦扬",
    "creator_uid": 1124,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1522639196",
    "length": 66
  },
  {
    "id": 3595,
    "uuid": "31b3894b-bd34-42b3-8e52-efa0ad445f96",
    "hitokoto": "下辈子变成你喜欢的人，然后不喜欢你！",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "alone88",
    "creator_uid": 1373,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523257159",
    "length": 18
  },
  {
    "id": 3607,
    "uuid": "f4058051-837e-499c-8153-a52c766f9a07",
    "hitokoto": "他能给的，你付不起！",
    "type": "f",
    "from": "终极恶女",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523579633",
    "length": 10
  },
  {
    "id": 3614,
    "uuid": "d8a874b9-e2f1-4013-a580-f290476093f2",
    "hitokoto": "自古表白多白表，从来情书难书情。笑谈年少多少年，常与生人道人生。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Administrator",
    "creator_uid": 1397,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523766466",
    "length": 32
  },
  {
    "id": 3615,
    "uuid": "9d15ee7c-b08b-4bb0-bdea-50642a0fb5bf",
    "hitokoto": "生活的洪流欲让人们窒息，我们却在缺氧的环境中肆意成长。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Administrator",
    "creator_uid": 1397,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523766515",
    "length": 27
  },
  {
    "id": 3616,
    "uuid": "e92b1e11-b626-4ebe-bab5-922ed9a2ef0e",
    "hitokoto": "有些人坐飞机就能见到，有些人坐时光机才可以。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Administrator",
    "creator_uid": 1397,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523766701",
    "length": 22
  },
  {
    "id": 3621,
    "uuid": "26fd1e1d-9d0d-476f-83ec-5a583ad1f671",
    "hitokoto": "你无法比此刻更年轻",
    "type": "f",
    "from": "一位网友",
    "from_who": null,
    "creator": "今朝有酒今朝醉",
    "creator_uid": 1406,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523972564",
    "length": 9
  },
  {
    "id": 3626,
    "uuid": "05dd54e1-b907-42ed-ad91-5735c900855a",
    "hitokoto": "这不是神经病，是理想",
    "type": "f",
    "from": "大话西游之紫霞仙子",
    "from_who": null,
    "creator": "papi",
    "creator_uid": 7,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1525252337",
    "length": 10
  },
  {
    "id": 3631,
    "uuid": "8cd68879-4fcb-48d1-a76f-cca5d7c22060",
    "hitokoto": "永远相信美好的事情，即将发生",
    "type": "f",
    "from": "XiaoMi",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1526096034",
    "length": 14
  },
  {
    "id": 3632,
    "uuid": "e26d3482-bb21-43ed-8072-3d5e5f30e11c",
    "hitokoto": "安静的心是最高的品质，它是没有分界的，完整的、纯洁的。他就是全神贯注、觉察力、爱和最高的智慧",
    "type": "f",
    "from": "Qihoo360",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1526096203",
    "length": 46
  },
  {
    "id": 3652,
    "uuid": "46b6ec55-5b03-4ce4-ade8-bc68ea21ae29",
    "hitokoto": "向来是据理力争，从不曾无理取闹。",
    "type": "f",
    "from": "胡向荣",
    "from_who": null,
    "creator": "RainAir",
    "creator_uid": 1613,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1528527140",
    "length": 16
  },
  {
    "id": 3669,
    "uuid": "605577db-1217-4f11-bb3c-3dc614bf7517",
    "hitokoto": "可这世间疾苦，照样没放过我",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530014258",
    "length": 13
  },
  {
    "id": 3676,
    "uuid": "8ae82850-8fb5-4619-a12b-64d2ba1e0dec",
    "hitokoto": "一切不谈语境的真理都是耍流氓",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530013927",
    "length": 14
  },
  {
    "id": 3684,
    "uuid": "b58f52fd-c5de-4f15-a6c6-d548b77e1d6f",
    "hitokoto": "我…真的…每天都在…尽最大的力气……去演一个正常人......或者说在强迫自己正常……求你放过我吧",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530014341",
    "length": 49
  },
  {
    "id": 3687,
    "uuid": "4a328ee7-973e-44db-a2d9-a7a2fdd6b529",
    "hitokoto": "没有光明是不幸的么？不，需要光明才是真正的不幸。",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530014475",
    "length": 24
  },
  {
    "id": 3695,
    "uuid": "29e28f16-f1cf-489c-9122-b9d0e2d07263",
    "hitokoto": "活着努力干，死了无遗憾！",
    "type": "f",
    "from": "Holio",
    "from_who": null,
    "creator": "holio",
    "creator_uid": 1777,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1531558126",
    "length": 12
  },
  {
    "id": 3696,
    "uuid": "0386002b-b155-4197-b3f0-7f6e1432f156",
    "hitokoto": "曾几何时，我们做了世上那最柔情的人，为一朵花低眉，为一朵云驻足，为一滴雨感动。",
    "type": "f",
    "from": "Qihoo360",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1531616468",
    "length": 39
  },
  {
    "id": 3705,
    "uuid": "c6e94d63-bbf8-43d1-bb35-88a2f476ef17",
    "hitokoto": "我有两个苹果，有个人问我要一个，我不给，于是很多人凑过来说你不是还有一个苹果吗，怎么这么小气啊。可是，苹果都是我的呀。",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530015119",
    "length": 59
  },
  {
    "id": 3709,
    "uuid": "02f3602b-19a8-4dc8-8cdc-7397e148abd4",
    "hitokoto": "双马尾是最好的方向盘",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "gerard",
    "creator_uid": 419,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532870532",
    "length": 10
  },
  {
    "id": 3722,
    "uuid": "b6d140f6-82d5-4771-9a1b-13f00c003488",
    "hitokoto": "活的越是绝望 写的词越是温柔 这也许是世间最大的讽刺",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530015433",
    "length": 26
  },
  {
    "id": 3724,
    "uuid": "d9c7a01c-5231-4df2-8de6-53c580fdaa2b",
    "hitokoto": "“每天都要等到困极了再睡 因为那样躺下就可以睡 就没有时间想那些不开心的事” ​",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530015544",
    "length": 40
  },
  {
    "id": 3725,
    "uuid": "007d0533-2e59-488d-9f49-06c089dec71a",
    "hitokoto": "恐惧的话，只是因为内心不够强大",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530015850",
    "length": 15
  },
  {
    "id": 3726,
    "uuid": "99fced6b-65c5-4088-9859-67de2f925d58",
    "hitokoto": "数学和物理，就是把看不见的星星写在了纸上。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530165874",
    "length": 21
  },
  {
    "id": 3727,
    "uuid": "2ee17dd5-caa6-4c5e-969a-4c167bb640dc",
    "hitokoto": "时间是一支孤寂的沙漏，一点一点地漏掉我们静默的年华，剩下比年华更加静默的回忆。",
    "type": "f",
    "from": "Qihoo360",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530166304",
    "length": 39
  },
  {
    "id": 3738,
    "uuid": "8c45096c-bc09-40dc-8f65-45f7950f51c8",
    "hitokoto": "借朋友的车开，朋友说还的时候要给车加油。还车时，我冲车鼓了鼓掌",
    "type": "f",
    "from": "Qihoo360",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532483400",
    "length": 31
  },
  {
    "id": 3750,
    "uuid": "7913cdd6-ccb6-457d-85a5-804896131077",
    "hitokoto": "人生是场马拉松，比的不是谁目前跑的快，也不是谁先跑到终点。而是怀着希望跑完全程，快慢无所谓因为每个人都活在自己的时区。只要坚持下去，不仅可以到达目的地实现梦想，还不会因为匆忙赶路而错过沿途的风景。",
    "type": "f",
    "from": "https://www.youtube.com/watch?v=BKHdQ0daAEw  评论区",
    "from_who": null,
    "creator": "luhahaha",
    "creator_uid": 1783,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533776363",
    "length": 98
  },
  {
    "id": 3753,
    "uuid": "f5a66296-6978-46f3-bd46-bbe9fafc5a84",
    "hitokoto": "大的目标，需要小的目标作铺垫，大的目标需要分割成几段一个一个去实现。",
    "type": "f",
    "from": "Qihoo360",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533108919",
    "length": 34
  },
  {
    "id": 3758,
    "uuid": "e95a6b4b-3df0-4f13-87ad-1725e037e01a",
    "hitokoto": "人生最好的三种状态：不期而遇、不言而喻、不药而愈——乃一俗人",
    "type": "f",
    "from": "网易云音乐",
    "from_who": null,
    "creator": "fu365主页",
    "creator_uid": 1728,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1531636007",
    "length": 30
  },
  {
    "id": 3759,
    "uuid": "4485cace-54f2-4372-9593-d1d43910b970",
    "hitokoto": "我是哑巴，你是瞎子，我们就这样保持最纯真的友谊，最遥远的爱情。",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "戎歌",
    "creator_uid": 1195,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532673494",
    "length": 31
  },
  {
    "id": 3760,
    "uuid": "d75b34ae-2e4f-419e-822a-401f8c58e300",
    "hitokoto": "永远不要活在过去的回忆里；昨天的太阳，晒不干今天的衣裳！",
    "type": "f",
    "from": "Qihoo360",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533008697",
    "length": 28
  },
  {
    "id": 3777,
    "uuid": "367c9147-c728-4f82-ab90-55a0eb1548f8",
    "hitokoto": "我李某相貌堂堂，妻子花容月貌，岂会生出你这种山野莽夫呢？",
    "type": "f",
    "from": "十万个冷笑话",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106633",
    "length": 28
  },
  {
    "id": 3778,
    "uuid": "8dd357e1-8611-49b6-ad05-12dc475d4918",
    "hitokoto": "我的每一个动作都有你的印记",
    "type": "f",
    "from": "十万个冷笑话",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106648",
    "length": 13
  },
  {
    "id": 3779,
    "uuid": "bcfb4a46-f831-4a4e-bd7b-d8fc4cbb1298",
    "hitokoto": "自古以来流传着这样一个传说 当集齐了七个福禄娃 放到炼丹炉中炼化 就能召唤出神龙，召的出才怪，你以为是龙珠啊。",
    "type": "f",
    "from": "十万个冷笑话",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106660",
    "length": 55
  },
  {
    "id": 3780,
    "uuid": "0ff27b0a-5598-4c3b-b905-4dc5360edca4",
    "hitokoto": "人生在世不称意，不如自挂东南枝",
    "type": "f",
    "from": "十万个冷笑话",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106675",
    "length": 15
  },
  {
    "id": 3781,
    "uuid": "9ea3a04d-1342-4ac3-a1cc-e280fefff574",
    "hitokoto": "火娃的熊熊烈焰 水娃的滔滔巨浪 当两种力量结合到一起的时候 就变成了 水蒸气",
    "type": "f",
    "from": "十万个冷笑话",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106686",
    "length": 38
  },
  {
    "id": 3782,
    "uuid": "ab9125ec-99c8-42d5-bca0-abe5c7c2a36f",
    "hitokoto": "看来你是不见棺材不落泪不到黄河心不死欲穷千里目更上一层楼呢",
    "type": "f",
    "from": "十万个冷笑话",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106722",
    "length": 29
  },
  {
    "id": 3803,
    "uuid": "7d36b519-82b2-4a4d-b7ef-c46f96e96304",
    "hitokoto": "impossible的完整形式是i'm possible",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "Soulter",
    "creator_uid": 1912,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533994085",
    "length": 28
  },
  {
    "id": 3812,
    "uuid": "1275f045-19bf-4602-9d18-ec9ef57c9945",
    "hitokoto": "我本将心向明月，奈何明月照沟渠。落花有意随流水，流水无心恋落花。",
    "type": "f",
    "from": "清诗纪事",
    "from_who": null,
    "creator": "etppt",
    "creator_uid": 1863,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533075299",
    "length": 32
  },
  {
    "id": 3813,
    "uuid": "9a80cb3f-cb40-40d2-9d84-40086d7ccc75",
    "hitokoto": "模拟只会猜题意,贪心只能过样例。数学上来先打表,DP一般看规律。组合数学靠运气,计算几何瞎暴力。图论一顿套模板,数论只会GCD。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "abc2237512422",
    "creator_uid": 1873,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1534578919",
    "length": 64
  },
  {
    "id": 3829,
    "uuid": "62c93a12-96ab-454c-9c95-dc937fb40c31",
    "hitokoto": "你总是这样轻言放弃的话，无论多久都只会原地踏步",
    "type": "f",
    "from": "Qihoo360",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535071907",
    "length": 23
  },
  {
    "id": 3830,
    "uuid": "941a0030-4cf3-4311-a510-3bb522a4b454",
    "hitokoto": "不要为小事遮住视线，我们还有更大的世界",
    "type": "f",
    "from": "Qihoo360",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535071861",
    "length": 19
  },
  {
    "id": 3831,
    "uuid": "cd71a826-39a2-49e6-8dc1-3db937815db1",
    "hitokoto": "厚道的人 运气都不会太差",
    "type": "f",
    "from": "Xiaomi",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535071832",
    "length": 12
  },
  {
    "id": 3832,
    "uuid": "815e62cc-1072-4c3b-b3a6-b06ea25f89b2",
    "hitokoto": "如果爱，请深爱，如不爱，请离开",
    "type": "f",
    "from": "Qihoo360",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1534994566",
    "length": 15
  },
  {
    "id": 3868,
    "uuid": "b031a9d3-61a6-4635-97bd-0ca3c45f2a15",
    "hitokoto": "万事开头难，然后中间难，最后结尾难。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "abc2237512422",
    "creator_uid": 1873,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535605405",
    "length": 18
  },
  {
    "id": 3870,
    "uuid": "0d309c76-9d77-4818-a3ea-b5e4f28f83d0",
    "hitokoto": "人红是非多，人傻当枪使。人蠢猛跟风，人笨不自知。",
    "type": "f",
    "from": "----来自网络",
    "from_who": null,
    "creator": "玉狐",
    "creator_uid": 1000,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536168128",
    "length": 24
  },
  {
    "id": 3874,
    "uuid": "8979bf46-21b3-4bbb-93dd-9d729fd57c84",
    "hitokoto": "承蒙遇见，三生有幸",
    "type": "f",
    "from": "晓良",
    "from_who": null,
    "creator": "晓良",
    "creator_uid": 2041,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536455451",
    "length": 9
  },
  {
    "id": 3877,
    "uuid": "52cdb86f-23a5-4bb2-a6ad-6439fdf6a837",
    "hitokoto": "没有音乐，生活是一种遗憾，没有爱心，生命是一种多余",
    "type": "f",
    "from": "Qihoo360",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536973711",
    "length": 25
  },
  {
    "id": 3878,
    "uuid": "0f921ae1-6340-45d6-82b6-58b2f58e728e",
    "hitokoto": "以爱回应忠诚，以荣誉回应英勇，以复仇回应背叛",
    "type": "f",
    "from": "Qihoo360",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536973745",
    "length": 22
  },
  {
    "id": 3880,
    "uuid": "2f95e1e1-be7d-4e92-9de7-22bab9bcb9b5",
    "hitokoto": "如果你是一匹千里马，那么请做自己的伯乐",
    "type": "f",
    "from": "Qihoo360",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537159093",
    "length": 19
  },
  {
    "id": 3881,
    "uuid": "6c3089f1-1c8a-4e0d-a6e4-b010e3b41b6b",
    "hitokoto": "世界上最美丽的就是世界本身",
    "type": "f",
    "from": "Qihoo360",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537159127",
    "length": 13
  },
  {
    "id": 3883,
    "uuid": "ce9e74bf-da86-43d0-84ec-c9900d227c49",
    "hitokoto": "我们不能成为贵族的后代，但我们可以变成贵族的祖先",
    "type": "f",
    "from": "Qihoo360",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537229032",
    "length": 24
  },
  {
    "id": 3884,
    "uuid": "1b79218f-acc0-4f9e-8c9f-0a07242fb0c8",
    "hitokoto": "我并没有找到真爱，但并不代表它不存在",
    "type": "f",
    "from": "Qihoo360",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537229070",
    "length": 18
  },
  {
    "id": 3927,
    "uuid": "e6697a88-4cf3-4f32-bc39-5efd9717ec52",
    "hitokoto": "保持好迎接强者的心态，才是初心",
    "type": "f",
    "from": "syc",
    "from_who": null,
    "creator": "byte",
    "creator_uid": 2089,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537620503",
    "length": 15
  },
  {
    "id": 3934,
    "uuid": "cbc82a97-d4ce-41af-af57-0f8a99acf5a6",
    "hitokoto": "童话只美在真实却从不续写。",
    "type": "f",
    "from": "世界沉睡童话",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538390876",
    "length": 13
  },
  {
    "id": 3937,
    "uuid": "67b05739-8fba-4efe-8f0f-8f78bf2fc710",
    "hitokoto": "积极者相信只有推动自己才能推动世界，只要推动自己就能推动世界。",
    "type": "f",
    "from": "Qihoo360",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538574734",
    "length": 31
  },
  {
    "id": 3939,
    "uuid": "55db5207-c784-452f-93b7-26fec150e257",
    "hitokoto": "有这种“自己又给人添麻烦了”的想法的人，都很敏感善良吧……",
    "type": "f",
    "from": "B、Mirror",
    "from_who": null,
    "creator": "mingcheng",
    "creator_uid": 2139,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538621960",
    "length": 29
  },
  {
    "id": 3952,
    "uuid": "a05190ce-7cd5-47b1-abad-7845a881be7e",
    "hitokoto": "脆弱的人才会四处游说自己的不幸，坚强的人只会不动声色地愈渐强大 。",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539278200",
    "length": 33
  },
  {
    "id": 3953,
    "uuid": "94bcc373-5c03-4cb2-b264-4c0ca11dfd14",
    "hitokoto": "虽然我们每个人都是宇宙中微不足道的尘埃，但可能是彼此眼中最亮的星。",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539350464",
    "length": 33
  },
  {
    "id": 3955,
    "uuid": "56e2f3da-a909-47bb-85a8-09bcb9ec8495",
    "hitokoto": "愿你遍布祖国山河，觉得人生也值得。",
    "type": "f",
    "from": "晓良",
    "from_who": null,
    "creator": "晓良",
    "creator_uid": 2041,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539491667",
    "length": 17
  },
  {
    "id": 3957,
    "uuid": "c143e19b-0701-4751-b4e7-fb60ab0508f5",
    "hitokoto": "谁能让我开心，我就喜欢谁",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "CrankAR",
    "creator_uid": 2131,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539616026",
    "length": 12
  },
  {
    "id": 3971,
    "uuid": "73dcd77f-35fa-461b-94bf-0d2ae335daea",
    "hitokoto": "你知不知道，难做的事和应该做的事，往往是同一件事。",
    "type": "f",
    "from": "天气预报员",
    "from_who": null,
    "creator": "Yolly",
    "creator_uid": 2273,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540993064",
    "length": 25
  },
  {
    "id": 3972,
    "uuid": "c132af15-215d-4028-bb13-5c87c95d319e",
    "hitokoto": "Think twice, code once.",
    "type": "f",
    "from": "毛啸",
    "from_who": null,
    "creator": "Logey",
    "creator_uid": 2210,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540952774",
    "length": 23
  },
  {
    "id": 3985,
    "uuid": "7ce5938b-cfc3-4fc8-89a6-77e3c3c73727",
    "hitokoto": "绝望自有绝望的力量，正如希望自有希望的无能.",
    "type": "f",
    "from": "XiaoMaFenJu",
    "from_who": null,
    "creator": "XiaoMaFenJu",
    "creator_uid": 2257,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540649492",
    "length": 22
  },
  {
    "id": 3987,
    "uuid": "e0adcb67-1d93-4eff-93a8-b267ecf1fcec",
    "hitokoto": "最令人伤心的事就是你发现自己已经做不好那件你曾经很擅长的事了。",
    "type": "f",
    "from": "elitegarfield",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540529526",
    "length": 31
  },
  {
    "id": 4023,
    "uuid": "a5a0d22a-170f-4b58-baa0-ce417c235344",
    "hitokoto": "善与恶逆转的瞬间，便是奇迹",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "世界唯一の勇者",
    "creator_uid": 243,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540444817",
    "length": 13
  },
  {
    "id": 4028,
    "uuid": "866a4cce-2c00-4cd3-b1dc-cc21b9067301",
    "hitokoto": "即使天还没有亮，固执做梦的人，身前会有光。",
    "type": "f",
    "from": "日食记",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540874866",
    "length": 21
  },
  {
    "id": 4054,
    "uuid": "84773a37-02fc-4509-854e-50483a20d7ff",
    "hitokoto": "为什么你宁愿吃生活上的苦 而不愿意吃学习上的苦？",
    "type": "f",
    "from": "知乎",
    "from_who": null,
    "creator": "Nihility",
    "creator_uid": 2330,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542188737",
    "length": 24
  },
  {
    "id": 4058,
    "uuid": "feee7b62-ad5d-476f-8f3b-9c143d354c7b",
    "hitokoto": "学生时代的恋爱教会了孩子们怎样以貌取人，在哪里都逃不掉这种烦人的原始社会残余。",
    "type": "f",
    "from": "鞠祖",
    "from_who": null,
    "creator": "Mockaven",
    "creator_uid": 701,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543668007",
    "length": 39
  },
  {
    "id": 4073,
    "uuid": "65980ded-6a3c-4b9f-855d-387922c20fd8",
    "hitokoto": "愿人生如剑、立起寒光四射、躺倒四射寒光",
    "type": "f",
    "from": "汪国真",
    "from_who": null,
    "creator": "一言小和尚",
    "creator_uid": 2393,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543226242",
    "length": 19
  },
  {
    "id": 4080,
    "uuid": "3ee52526-e528-4831-a1f4-75e5eae89ff4",
    "hitokoto": "锄禾日当午，贺题好辛苦，对着博客园，一贺一上午，贺了一上午，还要贺下午，不贺没前途，只能去跑路。",
    "type": "f",
    "from": "贺指导",
    "from_who": null,
    "creator": "mangoyang",
    "creator_uid": 1851,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539338396",
    "length": 48
  },
  {
    "id": 4081,
    "uuid": "4b8c3a1a-b3b2-422b-8aec-5d4008c08e6c",
    "hitokoto": "春来我不先游泳，哪只虫儿敢过江？",
    "type": "f",
    "from": "贺指导",
    "from_who": null,
    "creator": "mangoyang",
    "creator_uid": 1851,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539338420",
    "length": 16
  },
  {
    "id": 4082,
    "uuid": "920024dc-747b-4a70-90db-0022d070a03e",
    "hitokoto": "钱塘风雨起苍黄，贺鸡儿楠过大江",
    "type": "f",
    "from": "贺指导",
    "from_who": null,
    "creator": "mangoyang",
    "creator_uid": 1851,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539338436",
    "length": 15
  },
  {
    "id": 4115,
    "uuid": "35effde8-b080-4d58-871e-6519be1d504d",
    "hitokoto": "我们控制，我们收容，我们保护。",
    "type": "f",
    "from": "scp基金会",
    "from_who": null,
    "creator": "leo12",
    "creator_uid": 2264,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540745195",
    "length": 15
  },
  {
    "id": 4118,
    "uuid": "37fe1f57-ae05-4be5-bbcd-c4a0d990961d",
    "hitokoto": "有的时候我真觉得全世界都像海上撞沉了船，最要紧的还是救出自己",
    "type": "f",
    "from": "易卜生",
    "from_who": null,
    "creator": "766fr",
    "creator_uid": 2270,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540912628",
    "length": 30
  },
  {
    "id": 4119,
    "uuid": "db9249ac-366d-4303-b95b-082b153e7913",
    "hitokoto": "上帝不会为难头脑简单的孩子",
    "type": "f",
    "from": "句子迷",
    "from_who": null,
    "creator": "cyalias",
    "creator_uid": 647,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540912793",
    "length": 13
  },
  {
    "id": 4134,
    "uuid": "3f037f18-7e77-43ae-b7ce-50acd121614a",
    "hitokoto": "他们正热烈地讨论着别人的秘密，但是，一个不说，一个不听，还有一个不看。",
    "type": "f",
    "from": "躲进世界的角落",
    "from_who": null,
    "creator": "咸鱼",
    "creator_uid": 2375,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542937366",
    "length": 35
  },
  {
    "id": 4135,
    "uuid": "20ee2d34-cade-4468-9862-efc508f4c4f3",
    "hitokoto": "白天要好好读书，书里有你不知道的；夜晚要好好睡觉，梦里有你想要的 ​。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "醉梦大姐姐",
    "creator_uid": 2345,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543034905",
    "length": 35
  },
  {
    "id": 4136,
    "uuid": "96bd8d57-6d48-403b-ab4d-227fcb8eacd2",
    "hitokoto": "寻找比自己更没用的人，沉浸于这样的优越感中。",
    "type": "f",
    "from": "雨き声残響",
    "from_who": null,
    "creator": "茅台酒",
    "creator_uid": 2387,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543194688",
    "length": 22
  },
  {
    "id": 4139,
    "uuid": "65d236a2-35d3-4977-a862-761c9ae5a2cd",
    "hitokoto": "有时候会想，历史课本上的一句话，背后是那么多人的故事、那么多人的一生啊",
    "type": "f",
    "from": "豆瓣影评",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543277222",
    "length": 35
  },
  {
    "id": 4151,
    "uuid": "e77cbb7c-a826-451a-af6c-a14de8a0ab2d",
    "hitokoto": "花在女人身上的钱不能省，就算省了也不能让她知道。",
    "type": "f",
    "from": "Internet",
    "from_who": null,
    "creator": "nightkeeper",
    "creator_uid": 2454,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544287437",
    "length": 24
  },
  {
    "id": 4166,
    "uuid": "157d3021-4d95-4152-98b2-7727bf528787",
    "hitokoto": "有些路很远，走下去会很累。可是，不走，会后悔。",
    "type": "f",
    "from": "晓良",
    "from_who": null,
    "creator": "晓良",
    "creator_uid": 2041,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545383130",
    "length": 23
  },
  {
    "id": 4171,
    "uuid": "1381aa7b-528c-4a92-a9f5-6aa7390dd256",
    "hitokoto": "每天晚上想睡觉的时候，总是不由自主的想硬撑着不睡，没有在等什么，也不知道自己在熬什么",
    "type": "f",
    "from": "晓良",
    "from_who": null,
    "creator": "晓良",
    "creator_uid": 2041,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545382913",
    "length": 42
  },
  {
    "id": 4172,
    "uuid": "0cb796d6-4147-413b-93c7-17e3719b30f1",
    "hitokoto": "心情已经习惯和候鸟一起迁徙只是有些仓惶而已。",
    "type": "f",
    "from": "晓良",
    "from_who": null,
    "creator": "晓良",
    "creator_uid": 2041,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545383002",
    "length": 22
  },
  {
    "id": 4173,
    "uuid": "1bc73652-c577-44d0-9c80-fbdd46911ca1",
    "hitokoto": "你眼中的星海灿烂 是我不曾见过的世外桃源",
    "type": "f",
    "from": "晓良",
    "from_who": null,
    "creator": "晓良",
    "creator_uid": 2041,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545383079",
    "length": 20
  },
  {
    "id": 4189,
    "uuid": "0cc670b0-2442-4c6b-8bf5-a612681463bf",
    "hitokoto": "无论在多不幸的状况下，只要相信自己是幸福的，就能得到幸福。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "晓良",
    "creator_uid": 2041,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545382969",
    "length": 29
  },
  {
    "id": 4190,
    "uuid": "6fbf16d7-3fe7-4fec-9457-40af7280bf24",
    "hitokoto": "只有除了爱情什么都不缺的人，才有底气去等待爱情。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "頑張って！",
    "creator_uid": 2534,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545479996",
    "length": 24
  },
  {
    "id": 4197,
    "uuid": "b2a13e27-460d-40b1-9605-55542c473a8f",
    "hitokoto": "节日的意义，就是用美好的方式消耗时间",
    "type": "f",
    "from": "日食记",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545799070",
    "length": 18
  },
  {
    "id": 4198,
    "uuid": "2d5274a8-892e-4824-83a0-bdfa90194667",
    "hitokoto": "出言有尺，嬉闹有度，做事有余，说话有德。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "RGHSSS",
    "creator_uid": 2349,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545835005",
    "length": 20
  },
  {
    "id": 4213,
    "uuid": "cdb1facf-448a-4083-842c-c203572cb077",
    "hitokoto": "我想要山盟，你却带给我海誓。",
    "type": "f",
    "from": "山有木兮",
    "from_who": null,
    "creator": "a纱雾",
    "creator_uid": 1349,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1546000050",
    "length": 14
  },
  {
    "id": 4214,
    "uuid": "5eb5324d-de94-4077-bb65-b665e7e0cfea",
    "hitokoto": "我想去天涯，你却带我去海角。",
    "type": "f",
    "from": "山有木兮",
    "from_who": null,
    "creator": "a纱雾",
    "creator_uid": 1349,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1546000119",
    "length": 14
  },
  {
    "id": 4226,
    "uuid": "36b6e175-8da2-42f6-96cf-1b9c1dc98ef6",
    "hitokoto": "有生之年遇到你，竟花光我所有的运气。",
    "type": "f",
    "from": "林夕",
    "from_who": null,
    "creator": "RGHSSS",
    "creator_uid": 2349,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1546606251",
    "length": 18
  },
  {
    "id": 4229,
    "uuid": "0719b9ef-a675-42da-9f1e-a5874d835d98",
    "hitokoto": "别以为我长的帅就认为我遥不可及高不可攀，其实我是海纳百川啊！",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547700199",
    "length": 30
  },
  {
    "id": 4305,
    "uuid": "1d85d9ad-3cbe-4f22-954f-593f8007fcdb",
    "hitokoto": "不要刻意去猜测他人的想法，如果你没有智慧与经验的正确判断，通常都会有错误的。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551013411",
    "length": 38
  },
  {
    "id": 4327,
    "uuid": "fa295ea4-84d8-49c6-a162-26a0d3a7c58f",
    "hitokoto": "无论将来会遇到谁，生活都是先从遇到自己开始的。",
    "type": "f",
    "from": "苏晨",
    "from_who": null,
    "creator": "苏晨",
    "creator_uid": 3156,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556673673",
    "length": 23
  },
  {
    "id": 4330,
    "uuid": "7bb7b187-f237-4a38-acc9-e8ccbc31b25d",
    "hitokoto": "哪有什么人生开挂，不过是坚持很久的厚积薄发。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "althezsh",
    "creator_uid": 185,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555865815",
    "length": 22
  },
  {
    "id": 4349,
    "uuid": "07d1f187-9553-462c-b2b2-b8c55b8be9c8",
    "hitokoto": "我听到水流进入我的身体，我听到阳光穿透海面。",
    "type": "f",
    "from": "深蓝",
    "from_who": null,
    "creator": "lrxianed",
    "creator_uid": 2868,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1552036188",
    "length": 22
  },
  {
    "id": 4350,
    "uuid": "793426e4-0418-4f3c-94ad-b0ed31a1dd97",
    "hitokoto": "跑得快不一定赢，老跌跟头才是成功",
    "type": "f",
    "from": "8848",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1552197980",
    "length": 16
  },
  {
    "id": 4355,
    "uuid": "af07d133-7479-40a5-aa54-92ca70f9f3e4",
    "hitokoto": "梦终于醒了啊，期盼他日我们再萍水相逢吧。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "tgitc",
    "creator_uid": 3018,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556974561",
    "length": 20
  },
  {
    "id": 4360,
    "uuid": "a2c477a6-5097-4b25-8d37-fcef4b31620d",
    "hitokoto": "穿山甲到底说了什么？",
    "type": "f",
    "from": "暴走大事件",
    "from_who": null,
    "creator": "Loiko",
    "creator_uid": 3172,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556877898",
    "length": 10
  },
  {
    "id": 4365,
    "uuid": "ee6904cd-f6ef-49b6-9062-4bcb53465da7",
    "hitokoto": "扣首问路，码梦为生",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556070435",
    "length": 9
  },
  {
    "id": 4374,
    "uuid": "b6b4bc61-1038-4b26-b3d0-11dfdb0eb7ba",
    "hitokoto": "定义虽然精确，现实极度模糊。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553345651",
    "length": 14
  },
  {
    "id": 4375,
    "uuid": "0d41f76a-6852-47fd-9fd4-63679ae0a8aa",
    "hitokoto": "人每走一步都会损耗 0.6 秒的生命，难道我们会因此停滞不前吗？",
    "type": "f",
    "from": "恺伦",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553509496",
    "length": 32
  },
  {
    "id": 4383,
    "uuid": "81be1057-4897-4528-b2d4-b5475cdceac2",
    "hitokoto": "难受就是难受…不要让开心变成一种负担…",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556948286",
    "length": 19
  },
  {
    "id": 4388,
    "uuid": "7c203a83-9317-4fb2-b29f-1016df9a9c88",
    "hitokoto": "We always keep minority spirit.",
    "type": "f",
    "from": "minori",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1552367855",
    "length": 31
  },
  {
    "id": 4397,
    "uuid": "45e80d61-5631-4314-94c5-995716e10303",
    "hitokoto": "为什么要把眼影涂得那么红——可能是原来的样子太亲切了吧。",
    "type": "f",
    "from": "匿名",
    "from_who": null,
    "creator": "卢黑黑",
    "creator_uid": 2967,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553949199",
    "length": 28
  },
  {
    "id": 4398,
    "uuid": "556249ce-eb11-48ee-b294-a6805f90ef7a",
    "hitokoto": "今天地铁上明显少了很多人。",
    "type": "f",
    "from": "网易云音乐热评",
    "from_who": null,
    "creator": "FairHand",
    "creator_uid": 2963,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553907171",
    "length": 13
  },
  {
    "id": 4409,
    "uuid": "a64fdb12-5521-47cc-be58-b27acaa429bb",
    "hitokoto": "真正要分开的两个人，连“分手”二字都是多余的，因为殊途同归。",
    "type": "f",
    "from": "螚安Vivienne",
    "from_who": null,
    "creator": "FairHand",
    "creator_uid": 2963,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553906927",
    "length": 30
  },
  {
    "id": 4414,
    "uuid": "1572f9da-aced-4f18-8c74-edfbffdb25db",
    "hitokoto": "前路还很长，我会越来越好，你也不会差。我们各自珍重。",
    "type": "f",
    "from": "互联网",
    "from_who": null,
    "creator": "FairHand",
    "creator_uid": 2963,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553907147",
    "length": 26
  },
  {
    "id": 4418,
    "uuid": "c2d16f1e-612b-4038-9da6-399d9b88d4a0",
    "hitokoto": "想留的人却总难留，想说的话都到嘴边。",
    "type": "f",
    "from": "互联网",
    "from_who": null,
    "creator": "小轲",
    "creator_uid": 2984,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1554199288",
    "length": 18
  },
  {
    "id": 4426,
    "uuid": "6b7b0596-8cd6-4921-9ba5-6147c56288a5",
    "hitokoto": "労働者の命は何よりも大切です。",
    "type": "f",
    "from": "Internet",
    "from_who": null,
    "creator": "wycero",
    "creator_uid": 3075,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555823636",
    "length": 15
  },
  {
    "id": 4442,
    "uuid": "1667fc91-c9d4-47cd-83fc-fd08de6512c6",
    "hitokoto": "世界上只有一种真正的英雄主义，那就是在认清生活的真相后依然热爱生活。",
    "type": "f",
    "from": "米开朗基罗传",
    "from_who": null,
    "creator": "风待葬",
    "creator_uid": 3262,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1558542876",
    "length": 34
  },
  {
    "id": 4445,
    "uuid": "1266e517-baaf-4371-be5d-7d10078cdcd8",
    "hitokoto": "有幽默感的人，永远都不会默默无闻。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "告死ANGEL",
    "creator_uid": 3290,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1559016904",
    "length": 17
  },
  {
    "id": 4450,
    "uuid": "865e6816-8969-40e4-a0c6-14993578fc87",
    "hitokoto": "愿你以渺小启程，以伟大结束。",
    "type": "f",
    "from": "互联网",
    "from_who": null,
    "creator": "百事雪碧",
    "creator_uid": 3346,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560074747",
    "length": 14
  },
  {
    "id": 4455,
    "uuid": "6aedd8a5-b749-43f1-a2c5-97e18a906aff",
    "hitokoto": "人生真是讽刺，一个人竟然可以变成自己曾经最讨厌的样子",
    "type": "f",
    "from": "流浪记",
    "from_who": null,
    "creator": "QIQI",
    "creator_uid": 494,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1565244626",
    "length": 26
  },
  {
    "id": 4457,
    "uuid": "7500f910-006e-4df4-afdb-1915fe9c4245",
    "hitokoto": "我寻了半生的春天，你一笑便是了。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Yly",
    "creator_uid": 3624,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1565336650",
    "length": 16
  },
  {
    "id": 4478,
    "uuid": "4e867af8-07f0-4a7b-b917-2724217c1cb6",
    "hitokoto": "我只愿你们活着，为你们接风洗尘，带你们俯瞰星空，与你们共舞红尘。 我只愿你们活着。",
    "type": "f",
    "from": "网易云评论",
    "from_who": null,
    "creator": "17shou_VIP",
    "creator_uid": 2705,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560070571",
    "length": 41
  },
  {
    "id": 4479,
    "uuid": "ca1bcc08-dcf7-4480-897c-db0dc8bdee8a",
    "hitokoto": "我怕音乐，它总是让我想起一些不该想的事。他总是会让旧伤复发。",
    "type": "f",
    "from": "古龙",
    "from_who": null,
    "creator": "17shou_VIP",
    "creator_uid": 2705,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560070659",
    "length": 30
  },
  {
    "id": 4481,
    "uuid": "28ec0a85-c647-459e-9f16-7c4778c44e74",
    "hitokoto": "我好累啊，我终于变成了自己当初最讨厌的样子。",
    "type": "f",
    "from": "华子我想你",
    "from_who": null,
    "creator": "17shou_VIP",
    "creator_uid": 2705,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560070903",
    "length": 22
  },
  {
    "id": 4493,
    "uuid": "4ec80364-4b3a-4d81-8f68-376b3161e1fb",
    "hitokoto": "一天很短，开心了就笑，不开心了就过会儿再笑。",
    "type": "f",
    "from": "读者",
    "from_who": null,
    "creator": "水蜜桃",
    "creator_uid": 3385,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560912844",
    "length": 22
  },
  {
    "id": 4504,
    "uuid": "63633cf9-ca5c-4dc9-ad5e-6cfc35e23f93",
    "hitokoto": "你看这个碗他又大又圆~",
    "type": "f",
    "from": "Kris Wu",
    "from_who": null,
    "creator": "陈俊豪",
    "creator_uid": 3452,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562111561",
    "length": 11
  },
  {
    "id": 4505,
    "uuid": "b02bca83-823c-4eb2-a7ea-82bceae0f302",
    "hitokoto": "你看这个面他又长又宽~",
    "type": "f",
    "from": "Kris Wu",
    "from_who": null,
    "creator": "陈俊豪",
    "creator_uid": 3452,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562111578",
    "length": 11
  },
  {
    "id": 4514,
    "uuid": "dc8c124e-36db-49d4-a0ae-0b4d420eda94",
    "hitokoto": "The opoosite of depression is not happiness, but vitality.",
    "type": "f",
    "from": "Depression, the secret we share",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562755928",
    "length": 58
  },
  {
    "id": 4515,
    "uuid": "ad7bd9d2-3445-4938-b52e-3872770aa376",
    "hitokoto": "Depression is the flaw in love.",
    "type": "f",
    "from": "Depression, the secret we share",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562758388",
    "length": 31
  },
  {
    "id": 4535,
    "uuid": "306bb97b-14ec-4083-844e-0a977774dc13",
    "hitokoto": "前半生无你，余生请指教。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Venus",
    "creator_uid": 3500,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563006527",
    "length": 12
  },
  {
    "id": 4536,
    "uuid": "ae10a4aa-78d4-4ae1-b563-c1e97f425703",
    "hitokoto": "如果不被畏惧，神又何以为神。",
    "type": "f",
    "from": "网易云音乐",
    "from_who": null,
    "creator": "Venus",
    "creator_uid": 3500,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563015011",
    "length": 14
  },
  {
    "id": 4538,
    "uuid": "3ea228bb-fea2-40bd-86a3-b13299a141eb",
    "hitokoto": "这个世界上没有忽然崩溃的感情，只有压弯骆驼的最后一根稻草。",
    "type": "f",
    "from": "知乎匿名用户",
    "from_who": null,
    "creator": "QIQI",
    "creator_uid": 494,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563240200",
    "length": 29
  },
  {
    "id": 4541,
    "uuid": "d8df4bd8-8735-48d5-9b3d-f2f0b393ed70",
    "hitokoto": "爱永远不是在乎，而是正确的表达。",
    "type": "f",
    "from": "知乎用户肥叔",
    "from_who": null,
    "creator": "QIQI",
    "creator_uid": 494,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563273303",
    "length": 16
  },
  {
    "id": 4552,
    "uuid": "9a0f31b1-6b7d-474e-b32b-f5b3128552cc",
    "hitokoto": "大多数人高估了他们一天能做的事，但低估了他们一年能做的事。",
    "type": "f",
    "from": "阮一峰的博客",
    "from_who": null,
    "creator": "RtyXmd",
    "creator_uid": 3544,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563862604",
    "length": 29
  },
  {
    "id": 4555,
    "uuid": "55bea6d0-25a8-45a5-8f6e-151b5d66c353",
    "hitokoto": "数学期望小到渺茫又如何呢，哪怕结果不如人愿，也要在尘埃落定前奋起一搏。",
    "type": "f",
    "from": "Prayer_Descend",
    "from_who": null,
    "creator": "tgitc",
    "creator_uid": 3018,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1564050884",
    "length": 35
  },
  {
    "id": 4562,
    "uuid": "b05a8bd3-5947-4a04-b36e-f87b679cded4",
    "hitokoto": "牵着你手的时候，世界属于我。",
    "type": "f",
    "from": "啦啦啦种太阳",
    "from_who": null,
    "creator": "详情页评论模拟",
    "creator_uid": 3561,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1564193026",
    "length": 14
  },
  {
    "id": 4568,
    "uuid": "0dc730f5-8232-4b00-80e0-c8d5add4c129",
    "hitokoto": "“如果不曾开始，永远不会抵达。别忘了答应自己的事，别忘记想去的地方。”",
    "type": "f",
    "from": "一禅小和尚",
    "from_who": null,
    "creator": "牙人圭uu",
    "creator_uid": 3596,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1564921776",
    "length": 35
  },
  {
    "id": 4570,
    "uuid": "8cff0c07-5b56-495d-b7e0-168abeb91a14",
    "hitokoto": "如果必须要失去，那么不如一开始就不曾拥有。",
    "type": "f",
    "from": "知乎用户尚守晨",
    "from_who": null,
    "creator": "QIQI",
    "creator_uid": 494,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1565146744",
    "length": 21
  },
  {
    "id": 4573,
    "uuid": "bc97dff4-0a40-4448-8500-5b9e7d93797f",
    "hitokoto": "Dreams don't come for free. 梦想不会平白无故实现。",
    "type": "f",
    "from": "小七",
    "from_who": null,
    "creator": "北末",
    "creator_uid": 2040,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1565525733",
    "length": 39
  },
  {
    "id": 4574,
    "uuid": "3b995cde-d65d-456e-b67a-1a483a4c6766",
    "hitokoto": "书上说，如果有一天你梦见了一个很久没见的人，代表他/她正在遗忘你。",
    "type": "f",
    "from": "贫小子",
    "from_who": null,
    "creator": "贫小子",
    "creator_uid": 3646,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1565616255",
    "length": 33
  },
  {
    "id": 4590,
    "uuid": "a010d186-bb81-491d-a2a6-d4679c533e80",
    "hitokoto": "夏天重要的事不过一二：能够静静吹风，可以好好吃饭。",
    "type": "f",
    "from": "日食记",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566659381",
    "length": 25
  },
  {
    "id": 4622,
    "uuid": "be5845b8-b91d-476d-b0eb-4907dba5e417",
    "hitokoto": "花开如火，也如寂寞。",
    "type": "f",
    "from": "——顾城",
    "from_who": null,
    "creator": "sahara",
    "creator_uid": 1423,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567795200",
    "length": 10
  },
  {
    "id": 4624,
    "uuid": "7ff49c15-a58c-4ad9-9b13-36af038d0779",
    "hitokoto": "比起担心会后悔而什么都不做，还不如做完了再去后悔。",
    "type": "f",
    "from": "网络；忘记在哪看到的了",
    "from_who": null,
    "creator": "史诗级的肉卷丝",
    "creator_uid": 3866,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567880697",
    "length": 25
  },
  {
    "id": 4625,
    "uuid": "f4ce9b7b-cc74-450f-b36e-d1875ef87cce",
    "hitokoto": "永远不要放弃你真正想要得到的东西，等待虽难，但后悔更甚。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "苏宁",
    "creator_uid": 3872,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567942656",
    "length": 28
  },
  {
    "id": 4633,
    "uuid": "ceedd4bc-7dc3-4c1f-8fd2-dc54ff5c7983",
    "hitokoto": "自立自主总胜过俯首为奴！",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "网友CC、",
    "creator_uid": 3881,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1568016340",
    "length": 12
  },
  {
    "id": 4638,
    "uuid": "15d10d5b-f7f2-481f-b177-7003898aca76",
    "hitokoto": "所爱隔山海 山海亦可平",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "晴和君",
    "creator_uid": 3923,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1568870947",
    "length": 11
  },
  {
    "id": 4639,
    "uuid": "051aeb2c-5f66-4bc0-9271-1358cd027d63",
    "hitokoto": "岁月永远年轻，我们慢慢老去，你会发现，童心未泯是一件值得骄傲的事情。",
    "type": "f",
    "from": "宫崎骏",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1568951629",
    "length": 34
  },
  {
    "id": 4640,
    "uuid": "8ded38d9-72e0-4c1e-83fb-89747d3adbe6",
    "hitokoto": "数星星的孩子，是在和夜晚的星空交谈，而不是为了得到一个数字。",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1568951730",
    "length": 30
  },
  {
    "id": 4641,
    "uuid": "8b996ae2-0289-4717-bd38-acfb62d8d063",
    "hitokoto": "人类最高级别的安慰，就是理解别人的痛苦，并陪伴他。",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1568951681",
    "length": 25
  },
  {
    "id": 4644,
    "uuid": "d5ba5a37-c078-4f9f-8605-a4da38acc2e2",
    "hitokoto": "小时候词不达意，长大了言不由衷。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "伟.",
    "creator_uid": 3962,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569220489",
    "length": 16
  },
  {
    "id": 4645,
    "uuid": "78195693-73aa-43df-a55b-fee39c1be077",
    "hitokoto": "小时候怕鬼，因为他们面目狰狞；长大后怕人，因为他们衣冠楚楚。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "伟.",
    "creator_uid": 3962,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569220530",
    "length": 30
  },
  {
    "id": 4681,
    "uuid": "2623a0a9-6ba7-44d3-9332-56c23469cc4b",
    "hitokoto": "如果你希望自由，请以你的国家为荣。如果你希望民主，请维护自己的主权。如果你希望和平，请热爱你的国家。",
    "type": "f",
    "from": "唐纳德·特朗普",
    "from_who": null,
    "creator": "admin",
    "creator_uid": 2260,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1570069681",
    "length": 50
  },
  {
    "id": 4683,
    "uuid": "c7adcd60-71c0-4edd-a852-e13d0902a5cd",
    "hitokoto": "我们各自努力，最高处见。",
    "type": "f",
    "from": "知乎",
    "from_who": null,
    "creator": "憨憨",
    "creator_uid": 4021,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1570243761",
    "length": 12
  },
  {
    "id": 4783,
    "uuid": "b8b3e14b-1a81-402a-864a-d137eb0f60e7",
    "hitokoto": "雪崩时，没有一片雪花是无辜的！",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "M\u0026Yu",
    "creator_uid": 4055,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571143787",
    "length": 15
  },
  {
    "id": 4788,
    "uuid": "26598529-bdcd-46a5-85f2-abc25b011898",
    "hitokoto": "你只需看着别人精彩，老天对你另有安排",
    "type": "f",
    "from": "春天",
    "from_who": null,
    "creator": "春天",
    "creator_uid": 4104,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571538132",
    "length": 18
  },
  {
    "id": 4797,
    "uuid": "b83cde67-67c8-4691-85ea-94a202bc2963",
    "hitokoto": "音无结弦之日，悦动天使之心，立于浮华之世，奏响天籁之音",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "魑星辰",
    "creator_uid": 4074,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572012010",
    "length": 27
  },
  {
    "id": 4837,
    "uuid": "801e9675-f34a-4cd0-9692-38a1acbc5b8e",
    "hitokoto": "有钱人的生活，往往就是这么朴实无华，且枯燥。",
    "type": "f",
    "from": "朱一旦的枯燥生活",
    "from_who": null,
    "creator": "SUNJY",
    "creator_uid": 4165,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572329535",
    "length": 22
  },
  {
    "id": 4851,
    "uuid": "87d79763-f06a-4e7f-a241-bc8b9624f2e8",
    "hitokoto": "伟大的作品，就是抹去了时间的刻度，跨越了空间的距离，始终完成了陪伴这两个字。",
    "type": "f",
    "from": "微博",
    "from_who": null,
    "creator": "Lorangeve",
    "creator_uid": 4834,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581000798",
    "length": 38
  },
  {
    "id": 4852,
    "uuid": "416c0c3e-64e1-461a-ab25-e03642323ccc",
    "hitokoto": "无论遇到什么困难，也不要怕，微笑着面对它。消除恐惧的最好办法就是面对恐惧，坚持，才是胜利。加油，奥利给！",
    "type": "f",
    "from": "抖音",
    "from_who": "巨魔战将",
    "creator": "坐凳人",
    "creator_uid": 4832,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580979153",
    "length": 52
  },
  {
    "id": 4858,
    "uuid": "59cb1156-3658-42b5-8d14-13c97c29c7bb",
    "hitokoto": "还有问题想知道答案……但我已经是看过最多星星的一只兔子了！",
    "type": "f",
    "from": "新浪微博",
    "from_who": "月球车玉兔",
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370816",
    "length": 29
  },
  {
    "id": 4881,
    "uuid": "605120be-7876-4360-86d4-c99dc265ed94",
    "hitokoto": "从不犯错误的人终将一事无成",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "Suzushina_IkE",
    "creator_uid": 4285,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1573794627",
    "length": 13
  },
  {
    "id": 4882,
    "uuid": "ae916588-a221-44e8-9b3a-708296c79c43",
    "hitokoto": "对于讨厌的人不要想改变他，远离他才是上策。",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "Suzushina_IkE",
    "creator_uid": 4285,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1573794820",
    "length": 21
  },
  {
    "id": 4900,
    "uuid": "5a8f8c81-1f15-440d-b635-8ce04fa7a1f1",
    "hitokoto": "斯人若彩虹，遇上方知有。",
    "type": "f",
    "from": "怦然心动",
    "from_who": null,
    "creator": "夕之树",
    "creator_uid": 4248,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1573334249",
    "length": 12
  },
  {
    "id": 4918,
    "uuid": "758f5661-46cc-4249-a268-2d3ddf22356c",
    "hitokoto": "幸福往往是摸得透彻，而敬业的心却常常隐藏。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "语冰夏虫",
    "creator_uid": 2263,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1572014735",
    "length": 21
  },
  {
    "id": 4927,
    "uuid": "8089c924-0fc1-42e7-88db-e219cf0a7e92",
    "hitokoto": "爷爷没有输给战火，父亲没有输给贫穷，我却输给了和平年代的生活和爱情，以及太过自由",
    "type": "f",
    "from": "皮皮虾",
    "from_who": null,
    "creator": "皮皮虾",
    "creator_uid": 4347,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574612994",
    "length": 40
  },
  {
    "id": 4928,
    "uuid": "4c592612-3454-47ab-9b97-f52169806fb5",
    "hitokoto": "鱼与熊掌不可兼得，唯独穷和单身可以",
    "type": "f",
    "from": "皮皮虾",
    "from_who": null,
    "creator": "皮皮虾",
    "creator_uid": 4347,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574613017",
    "length": 17
  },
  {
    "id": 4932,
    "uuid": "f50f3fe3-4bbf-40d2-9810-a7fddcb69582",
    "hitokoto": "行为发展成习惯，习惯发展成为性格，性格伴随人的一生。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "alterem",
    "creator_uid": 4351,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574840426",
    "length": 26
  },
  {
    "id": 4935,
    "uuid": "461cca36-ba8e-4d78-91cc-1d07ccd9fcbd",
    "hitokoto": "门不当，户不对，没点儿本事别遭罪，你是好人，我不配，忘了我吧，下一位，skr",
    "type": "f",
    "from": "一个转身的距离",
    "from_who": null,
    "creator": "冷兮",
    "creator_uid": 4121,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575263465",
    "length": 38
  },
  {
    "id": 4936,
    "uuid": "f47407d6-fa96-4a81-9669-d5c619dd4d68",
    "hitokoto": "百般乐器，唢呐为王；不是升天，就是拜堂。",
    "type": "f",
    "from": "一个转身的距离",
    "from_who": null,
    "creator": "冷兮",
    "creator_uid": 4121,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575263484",
    "length": 20
  },
  {
    "id": 4937,
    "uuid": "bf1e88d0-14a8-4c25-8467-aaf4e320dc6e",
    "hitokoto": "鞭炮再响，可哪有我想你那么想",
    "type": "f",
    "from": "一个转身的距离",
    "from_who": null,
    "creator": "冷兮",
    "creator_uid": 4121,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575263527",
    "length": 14
  },
  {
    "id": 4956,
    "uuid": "78a352f7-0d79-4663-bac0-fd07ca246e7f",
    "hitokoto": "连我自己都轻视自己的话，谁来夸奖我啊，只有我了，舍我其谁。",
    "type": "f",
    "from": "笹木咲",
    "from_who": null,
    "creator": "ouuan",
    "creator_uid": 2676,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1576373899",
    "length": 29
  },
  {
    "id": 4957,
    "uuid": "68e20644-d3d2-4796-869d-b4abf8ea574e",
    "hitokoto": "即使窗外天寒地冻，吃一口肉，一切自有力量。",
    "type": "f",
    "from": "日食记",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1576578772",
    "length": 21
  },
  {
    "id": 4961,
    "uuid": "c1d0cc8a-4a4e-4ece-b2d3-70ba4fbc7292",
    "hitokoto": "一生败在太没钱，不敢爱她太明显。",
    "type": "f",
    "from": "内涵段子TV",
    "from_who": null,
    "creator": "凡为过往，皆为序章",
    "creator_uid": 4914,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581668762",
    "length": 16
  },
  {
    "id": 4968,
    "uuid": "febebf41-6b08-4d81-ad73-23dd9b4f6365",
    "hitokoto": "胸中有丘壑，立马镇山河。",
    "type": "f",
    "from": "热血",
    "from_who": null,
    "creator": "梵川",
    "creator_uid": 4860,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581665197",
    "length": 12
  },
  {
    "id": 4974,
    "uuid": "6ec39279-460a-419e-bbc2-87d1aaf3ad58",
    "hitokoto": "--Tell me, do gods bleed? --No, but you will!",
    "type": "f",
    "from": "烦人的村民",
    "from_who": "M.r.FudgeMonkeyz",
    "creator": "404NOTFOUND",
    "creator_uid": 4166,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581597617",
    "length": 45
  },
  {
    "id": 4976,
    "uuid": "c7c3dece-5122-4fed-b27f-519fc48c179e",
    "hitokoto": "笑容不一定是开心，也许是一种无奈；流泪不一定是伤心，也许是一种释放；心痛不一定是受伤，也许是一种心动",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "kirito",
    "creator_uid": 4899,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581593156",
    "length": 50
  },
  {
    "id": 5025,
    "uuid": "4b607f19-9335-4931-979f-1906e64ef437",
    "hitokoto": "任何一个伟大的目标，都有一个微不足道的开始",
    "type": "f",
    "from": "洛谷",
    "from_who": null,
    "creator": "焦糖玛奇朵",
    "creator_uid": 4516,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1576918456",
    "length": 21
  },
  {
    "id": 5047,
    "uuid": "0edf521f-376c-4663-9347-e58300f9da1c",
    "hitokoto": "一个人如果走在了时代的前面，他身后的时代会把他抛弃。",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "QIQI",
    "creator_uid": 494,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578739550",
    "length": 26
  },
  {
    "id": 5056,
    "uuid": "e6109211-9139-4f4a-aecf-01be61642083",
    "hitokoto": "请成为永远疯狂 ，永远浪漫 ，永远清澈的存在。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "信徒",
    "creator_uid": 4679,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1579420638",
    "length": 23
  },
  {
    "id": 5060,
    "uuid": "ffad0079-be5b-4a3b-a71f-628ef2e04190",
    "hitokoto": "对自己的爱好保持热情，不要太功利！",
    "type": "f",
    "from": "网络",
    "from_who": "我叫何同学",
    "creator": "小忧忧",
    "creator_uid": 4701,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1579631729",
    "length": 17
  },
  {
    "id": 5062,
    "uuid": "cc3b8794-84c1-4a3b-bdf1-bca37d96cc6f",
    "hitokoto": "能轻易离开的人确实谈不上遗憾",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "童年往事",
    "creator_uid": 4648,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578991952",
    "length": 14
  },
  {
    "id": 5089,
    "uuid": "94b43169-7951-49fa-a2b6-6254de1d662a",
    "hitokoto": "\r\n沾酒不醉那是喝的少，见色不迷那是摸不着，淡泊名利那是实在没招",
    "type": "f",
    "from": "来自网络",
    "from_who": "郭德纲",
    "creator": "深蓝色的裤头",
    "creator_uid": 5026,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582437746",
    "length": 32
  },
  {
    "id": 5106,
    "uuid": "eb28690e-6cf4-41a9-b537-e243cf484192",
    "hitokoto": "后来躺进你黑名单里的那个人最开始也是踏着七色云彩照亮过你整个世界的人。",
    "type": "f",
    "from": "不必",
    "from_who": "墨白",
    "creator": "墨客熊",
    "creator_uid": 4413,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1582256157",
    "length": 35
  },
  {
    "id": 5113,
    "uuid": "4bb86ecd-e852-42ab-a4cb-c0017bb6f02b",
    "hitokoto": "生气归生气，又不是不爱你……",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "西边的little star",
    "creator_uid": 5038,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1582501768",
    "length": 14
  },
  {
    "id": 5115,
    "uuid": "54c0277d-2852-4ef8-a43e-00e2f0ba0c5c",
    "hitokoto": "我已经完全爱上沃玛(Warma)了！",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "坐凳人",
    "creator_uid": 4832,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581819944",
    "length": 18
  },
  {
    "id": 5124,
    "uuid": "5c883f65-a60b-4029-9274-7e2da8bea37c",
    "hitokoto": "再凶的男孩子，绑鞋带还不是要系蝴蝶结。",
    "type": "f",
    "from": "签名",
    "from_who": null,
    "creator": "童年往事",
    "creator_uid": 4648,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1578992123",
    "length": 19
  },
  {
    "id": 5127,
    "uuid": "6491e5d6-eae7-4a6a-bd11-d828f6d668b6",
    "hitokoto": "大家都说我的性子很慢，其实我也可以很快。比如，后面有狗追我；或者，你在前面等我。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "童年往事",
    "creator_uid": 4648,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1578991996",
    "length": 40
  },
  {
    "id": 5133,
    "uuid": "e1da6cf2-0ad8-4ed7-848b-0138a25e3d45",
    "hitokoto": "这个社会一直在淘汰有学历的人，但是不会淘汰有学习力的人。",
    "type": "f",
    "from": "Mr96",
    "from_who": null,
    "creator": "Mr96",
    "creator_uid": 4362,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1574720644",
    "length": 28
  },
  {
    "id": 5135,
    "uuid": "a15c580c-bfc6-4f95-be3a-05d825c9fba1",
    "hitokoto": "新鲜感是和旧人去体验新事物，不是和新人去循环旧事物。",
    "type": "f",
    "from": "微博",
    "from_who": null,
    "creator": "一直菜花",
    "creator_uid": 4384,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1575117866",
    "length": 26
  },
  {
    "id": 5156,
    "uuid": "be3980ec-c9a2-4628-9e9f-93c7055ba3f4",
    "hitokoto": "人不患不知人，患不知己。",
    "type": "f",
    "from": "知乎",
    "from_who": null,
    "creator": "韬光隐迹",
    "creator_uid": 5086,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1582708999",
    "length": 12
  },
  {
    "id": 5157,
    "uuid": "5f65c65a-5a60-4788-b2d7-d8deb4eccb1a",
    "hitokoto": "互联网时代的悲哀就是让你知道了皇帝的生活，而你只是个佃户。",
    "type": "f",
    "from": "知乎",
    "from_who": null,
    "creator": "韬光隐迹",
    "creator_uid": 5086,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1582709791",
    "length": 29
  },
  {
    "id": 5161,
    "uuid": "277f1ab3-21ba-4284-a702-2b718b2927ed",
    "hitokoto": "剩下的仅是一片星光，几簇未了的星尘，在将远行的日光中，留下月的影子。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "MoonDrop",
    "creator_uid": 5112,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1582807300",
    "length": 34
  },
  {
    "id": 5169,
    "uuid": "833a4fb8-73e7-473a-ac81-7d0398630dd6",
    "hitokoto": "没心没肺，活着不累。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "2247",
    "creator_uid": 5148,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582967894",
    "length": 10
  },
  {
    "id": 5193,
    "uuid": "9da9d486-fe09-43f2-bd84-1b2be2d66921",
    "hitokoto": "哪有什么岁月静好，不过是有人在替你负重前行。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Aldrich",
    "creator_uid": 5178,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583204771",
    "length": 22
  },
  {
    "id": 5195,
    "uuid": "760a4385-1586-4555-b4dc-7d7455c6f1d8",
    "hitokoto": "“对方正在输入中”，给了多少人希望，又让多少人绝望。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "Polaris",
    "creator_uid": 5204,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583217765",
    "length": 26
  },
  {
    "id": 5219,
    "uuid": "f0421921-1294-4f8a-8eb7-8cbe8fc55360",
    "hitokoto": "水的清澈，并非因为它不含杂质，而是在于懂得沉淀。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "qwqbear",
    "creator_uid": 3516,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583661311",
    "length": 24
  },
  {
    "id": 5222,
    "uuid": "a550694a-a373-4e8c-aabf-82fc76318140",
    "hitokoto": "我们没有相见，却是此刻最好的相聚。",
    "type": "f",
    "from": "日食记",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583510225",
    "length": 17
  },
  {
    "id": 5231,
    "uuid": "be0ee57a-8d15-4e00-949b-c962e02b909e",
    "hitokoto": "犹豫就会败北，果断就会白给。",
    "type": "f",
    "from": "网友",
    "from_who": null,
    "creator": "187J3X1",
    "creator_uid": 4787,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583626125",
    "length": 14
  },
  {
    "id": 5240,
    "uuid": "934f0d85-c7b4-4979-bb44-4825ef1f9ef4",
    "hitokoto": "听闻远方有你，动身跋涉千里；我吹过你吹过的风，这算不算相拥。",
    "type": "f",
    "from": "抖音",
    "from_who": "暴走的芊芊吖",
    "creator": "Mint",
    "creator_uid": 5006,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583812625",
    "length": 30
  },
  {
    "id": 5247,
    "uuid": "c62cb2d5-ea8a-4608-8654-cb8b0ea4fd41",
    "hitokoto": "I like you, but just like you.",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "狂三游六花。",
    "creator_uid": 5315,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1583806352",
    "length": 30
  },
  {
    "id": 5248,
    "uuid": "d7bbc3dd-9f5f-4d3f-979c-c40e5018a006",
    "hitokoto": "心不动，则不痛；爱不离，则不弃。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "狂三游六花。",
    "creator_uid": 5315,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1583809226",
    "length": 16
  },
  {
    "id": 5252,
    "uuid": "8feabad3-35bc-4edc-8752-a35eae0617cd",
    "hitokoto": "死去的人不需要花。被花所拯救的是留下来的人。",
    "type": "f",
    "from": "bgm.tv",
    "from_who": "伪春菜",
    "creator": "Coral",
    "creator_uid": 5360,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583940746",
    "length": 22
  },
  {
    "id": 5275,
    "uuid": "686fca99-e420-47e2-b239-4e298ab47658",
    "hitokoto": "以前喜欢一个人，现在喜欢一个人。",
    "type": "f",
    "from": "QQ音乐热评",
    "from_who": "QQ音乐用户",
    "creator": "晚柠",
    "creator_uid": 5345,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1584175950",
    "length": 16
  },
  {
    "id": 5278,
    "uuid": "ab51f840-5453-495a-8398-5da8b1e9d3f9",
    "hitokoto": "我特别喜欢“您”这个字，因为它的意思是，心上有你。",
    "type": "f",
    "from": "知乎",
    "from_who": null,
    "creator": "宋锦瑟",
    "creator_uid": 5194,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1584263642",
    "length": 25
  },
  {
    "id": 5378,
    "uuid": "551b63a6-8ab8-4e8e-b2ea-9e5e4425df2f",
    "hitokoto": "脑子是个好东西，打从娘胎它就开始运转，但进了国会它就不运转了。",
    "type": "f",
    "from": "美国共和党国会议员",
    "from_who": null,
    "creator": "admin",
    "creator_uid": 3800,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585050437",
    "length": 31
  },
  {
    "id": 5386,
    "uuid": "84ece63a-e7e1-4f89-b8f9-eddadbdfdb1e",
    "hitokoto": "不要在晚上做出任何决定。",
    "type": "f",
    "from": "互联网",
    "from_who": null,
    "creator": "lzt",
    "creator_uid": 5623,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585139757",
    "length": 12
  },
  {
    "id": 5398,
    "uuid": "aae28604-5146-414d-9ef8-64d25e9459e4",
    "hitokoto": "因为无能为力，所以顺其自然。因为心无所恃，所以随遇而安。",
    "type": "f",
    "from": "未知",
    "from_who": "未知",
    "creator": "ash",
    "creator_uid": 5670,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585366410",
    "length": 28
  },
  {
    "id": 5408,
    "uuid": "9357e70b-7c00-4d7f-9d60-85c5c2da906c",
    "hitokoto": "机场永远等不到船，就像我永远等不到你。",
    "type": "f",
    "from": "网络",
    "from_who": "某网友",
    "creator": "小新",
    "creator_uid": 5703,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585607330",
    "length": 19
  },
  {
    "id": 5413,
    "uuid": "901a3a77-e851-47cc-8978-80e156ec58b0",
    "hitokoto": "用柔软的面点，对抗这个坚硬的世界吧。",
    "type": "f",
    "from": "日食记",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585759455",
    "length": 18
  },
  {
    "id": 5418,
    "uuid": "15975da5-b1a3-4f58-8d6b-554cc2c42c37",
    "hitokoto": "人生就像爬楼梯，只有脚踏实地的向上，才能到达屋顶。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "hkaren",
    "creator_uid": 5713,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585647188",
    "length": 25
  },
  {
    "id": 5419,
    "uuid": "0c804669-06c4-4d5b-b151-44901b56c206",
    "hitokoto": "黎明之前总有一段时间特别黑。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Soiltary、K",
    "creator_uid": 3915,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585672946",
    "length": 14
  },
  {
    "id": 5430,
    "uuid": "206c7881-a44b-4b9b-bf5b-511cd9b3a299",
    "hitokoto": "当眼泪流下来，才知道，分开也是另一种明白。",
    "type": "f",
    "from": "网络",
    "from_who": "佚名",
    "creator": "何叶",
    "creator_uid": 5724,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585669139",
    "length": 21
  },
  {
    "id": 5434,
    "uuid": "9287fcc8-2c76-4ab1-bd18-55c6d0bbc7b4",
    "hitokoto": "小时候，奶奶说亲人去世以后会变成蝴蝶。奶奶去世之后，每当有蝴蝶飞到屋子里，我都会关上窗。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "molamola",
    "creator_uid": 5761,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585851293",
    "length": 44
  },
  {
    "id": 5438,
    "uuid": "e5b9b9f2-ad14-4b4e-b8d2-38d8e8796cd7",
    "hitokoto": "青春是一场不会回头的风，它呼啸而来呼啸而去，最终离我们远去，一点不剩。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "何叶",
    "creator_uid": 5724,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586056301",
    "length": 35
  },
  {
    "id": 5440,
    "uuid": "d254cbfe-7b49-4f7b-b053-2f0b9a874d99",
    "hitokoto": "人的伟大之处是在于面对困难的时候还能摆出崇高的姿态。",
    "type": "f",
    "from": "超级教师",
    "from_who": null,
    "creator": "雨啸青锋",
    "creator_uid": 5808,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586142672",
    "length": 26
  },
  {
    "id": 5494,
    "uuid": "c7646d86-6dba-45c7-a4fa-45c8aa78a659",
    "hitokoto": "你是我羽翼下的风。",
    "type": "f",
    "from": "Siri",
    "from_who": null,
    "creator": "sjfhsjfh",
    "creator_uid": 4997,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586157037",
    "length": 9
  },
  {
    "id": 5980,
    "uuid": "66e8ac5d-680e-4a74-b6ab-4d517b83011b",
    "hitokoto": "你站在高处，就少往下看。",
    "type": "f",
    "from": "b站评论",
    "from_who": "rgo142",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1588164388",
    "length": 12
  },
  {
    "id": 5987,
    "uuid": "59f8b7f0-c967-4823-8ccb-a11cadde25c9",
    "hitokoto": "总会有那么一天，放下如今的执着和不舍，带着稍许的遗憾，去开始过没有那个人的新生活。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586341573",
    "length": 41
  },
  {
    "id": 5988,
    "uuid": "749f7393-79db-41d8-893c-cc8b8e66bacd",
    "hitokoto": "春天适合努力和拥抱。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586341605",
    "length": 10
  },
  {
    "id": 5989,
    "uuid": "276a8f6b-326a-4e66-80a7-46b307951525",
    "hitokoto": "把温柔和心软留给值得的人。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586341691",
    "length": 13
  },
  {
    "id": 5990,
    "uuid": "10482b23-bc16-4640-ac66-c6e94f666567",
    "hitokoto": "你逆光而来，配得上世间所有的美好。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586341705",
    "length": 17
  },
  {
    "id": 5991,
    "uuid": "5f6a0632-76b8-489e-b9c0-b34257842be2",
    "hitokoto": "我从他的生命里消失，而他依然闪亮。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586341723",
    "length": 17
  },
  {
    "id": 5992,
    "uuid": "71d28741-11f6-4787-8c9d-ac8035e34a3c",
    "hitokoto": "你搅散一池星光成为我的月亮。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586341795",
    "length": 14
  },
  {
    "id": 5993,
    "uuid": "87ebe748-cb98-4080-9631-56307c1b0021",
    "hitokoto": "他会找到别的月光，你也会拥有你的月亮。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586341876",
    "length": 19
  },
  {
    "id": 5994,
    "uuid": "7e6e8b78-56ac-47fb-ad2b-d32a30a8c994",
    "hitokoto": "能不能停下来，看看那个满眼泪花奔向你的我。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586341893",
    "length": 21
  },
  {
    "id": 5995,
    "uuid": "de49ff90-2d84-43c2-9248-bbf012c2a1be",
    "hitokoto": "事已至此，幸而夜风对他温柔。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586341911",
    "length": 14
  },
  {
    "id": 5996,
    "uuid": "ada40601-5a04-467a-8519-6a85a5e76c90",
    "hitokoto": "就算终有一散也别辜负相遇。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586341932",
    "length": 13
  },
  {
    "id": 5997,
    "uuid": "fe21d1c0-4739-4b8d-b929-0fab7aaa4b98",
    "hitokoto": "你依然让我觉得美好且心动，但我已经没有力气和勇气再去拥抱。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586341969",
    "length": 29
  },
  {
    "id": 5998,
    "uuid": "04afa579-e9a9-4905-9834-cf08d824cc49",
    "hitokoto": "你要储蓄你的可爱眷顾你的善良，变得勇敢，当这个世界越来越坏时只希望你能越来越好。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586342079",
    "length": 40
  },
  {
    "id": 5999,
    "uuid": "15b14ba9-2711-4414-8b20-88d0c453d432",
    "hitokoto": "今日过后，所有晦暗都留给过往，凛冬散尽，星河长明。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586342145",
    "length": 25
  },
  {
    "id": 6002,
    "uuid": "eb85cee0-61ba-42b5-b47a-3f64e15113eb",
    "hitokoto": "为众人抱薪者，不可使其冻毙于风雪。为自由开道者，不可令其困厄于荆棘。",
    "type": "f",
    "from": "微博",
    "from_who": "慕容雪村",
    "creator": "机智的狐狸菌",
    "creator_uid": 5198,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586479818",
    "length": 34
  },
  {
    "id": 6018,
    "uuid": "fc01370f-ef1c-45f5-ac74-efd84ab2e557",
    "hitokoto": "过去已成过去，将来还是将来，而我们能改变的只有现在。",
    "type": "f",
    "from": "网络",
    "from_who": "网友",
    "creator": "005",
    "creator_uid": 4640,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1586650226",
    "length": 26
  },
  {
    "id": 6033,
    "uuid": "9f8e468c-0068-4469-bca3-5a86b5d1b934",
    "hitokoto": "假如，生活欺骗了你。你不要难过，不要悲伤。因为，它不止一次欺骗了你。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "旋风",
    "creator_uid": 5913,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587043684",
    "length": 34
  },
  {
    "id": 6037,
    "uuid": "1880f080-b1cf-4ee2-a86d-d0cd84bf8577",
    "hitokoto": "愿你的青春如花般绽放。",
    "type": "f",
    "from": "QQ空间",
    "from_who": null,
    "creator": "陌人犹未归",
    "creator_uid": 5933,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587105044",
    "length": 11
  },
  {
    "id": 6038,
    "uuid": "6d5ff9e6-87a4-4a83-81cc-13751c0482f2",
    "hitokoto": "梦想还是要有的，万一见鬼了呢？",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "qwqbear",
    "creator_uid": 3516,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587110305",
    "length": 15
  },
  {
    "id": 6085,
    "uuid": "677a3dcc-90f3-4b04-95b2-d65652b8bcd6",
    "hitokoto": "路为纸，地成册，行做笔，心当墨。",
    "type": "f",
    "from": "CCTV9",
    "from_who": null,
    "creator": "司徒和丞相",
    "creator_uid": 4434,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588301055",
    "length": 16
  },
  {
    "id": 6090,
    "uuid": "1f36491c-ebe5-4ef0-b94e-80138696a49d",
    "hitokoto": "你所见即是我，好与坏我都不反驳。我所爱即使你，好与坏我都能接受。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "xiaoz",
    "creator_uid": 6104,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588496980",
    "length": 32
  },
  {
    "id": 6101,
    "uuid": "0d4c4f83-095b-4701-a115-e3658b1494b9",
    "hitokoto": "从前总说，海底月是天上月，眼前人是以上人。后来懂得，海底月捞不起，心上人不可及。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "xiaoz",
    "creator_uid": 6104,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1588497100",
    "length": 40
  },
  {
    "id": 6127,
    "uuid": "41d4be02-6c9e-40bc-a02e-a9badb622a11",
    "hitokoto": "没什么做起来是容易的，但只要你还能呼吸，离梦想实现永远只差那么一口气。让你的每一次呼吸都能够起效。",
    "type": "f",
    "from": "健身圈",
    "from_who": "Kai Greene",
    "creator": "Liak",
    "creator_uid": 6141,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588761307",
    "length": 49
  },
  {
    "id": 6135,
    "uuid": "a5faf166-4696-4345-838c-579a2059438e",
    "hitokoto": "你知道什么叫幸福嘛？幸福就是拍拍手。",
    "type": "f",
    "from": "哔哩哔哩",
    "from_who": "我是皮皮参",
    "creator": "皮皮参",
    "creator_uid": 6402,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591426396",
    "length": 18
  },
  {
    "id": 6139,
    "uuid": "29506e97-85a5-4df8-bffa-346987ff9d88",
    "hitokoto": "我拯救了全世界，全世界却抛弃了我。",
    "type": "f",
    "from": "哔哩哔哩",
    "from_who": null,
    "creator": "皮皮参",
    "creator_uid": 6402,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591426015",
    "length": 17
  },
  {
    "id": 6147,
    "uuid": "9541ecf7-9215-4bbc-89be-f12f12caecf3",
    "hitokoto": "Can you paint with the colors of the wind?",
    "type": "f",
    "from": "Pocahontas - Colors of the Wind",
    "from_who": "Pocahontas",
    "creator": "foreversama",
    "creator_uid": 3576,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589112273",
    "length": 42
  },
  {
    "id": 6162,
    "uuid": "4f3f0bd8-822a-4d4a-ac4f-bcdb89a71b65",
    "hitokoto": "经典之所以称之为经典，因为它能经得起时间的考验。",
    "type": "f",
    "from": "哔哩哔哩",
    "from_who": null,
    "creator": "砂水c",
    "creator_uid": 6215,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589455340",
    "length": 24
  },
  {
    "id": 6171,
    "uuid": "701002a7-03bc-4b0b-ac62-4de37a3286de",
    "hitokoto": "别丧了，说不定你也是别人心中偷偷藏起来的光。",
    "type": "f",
    "from": "网络",
    "from_who": "一个可爱的人吧",
    "creator": "XrCuWa",
    "creator_uid": 6239,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589873287",
    "length": 22
  },
  {
    "id": 6174,
    "uuid": "f6b14e22-5408-4bf5-9cd4-28e6044b6bab",
    "hitokoto": "每一次选择，都要为其承担后果。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589905867",
    "length": 15
  },
  {
    "id": 6214,
    "uuid": "df95e3f6-7603-4085-ad8f-17e7e57c7b60",
    "hitokoto": "改革不停顿，开放不止步。",
    "type": "f",
    "from": "习近平总书记改革开放金句",
    "from_who": "习近平",
    "creator": "LemonPig",
    "creator_uid": 6267,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590580002",
    "length": 12
  },
  {
    "id": 6239,
    "uuid": "cd82be88-5cd9-4042-8539-ea9b5bbaa21c",
    "hitokoto": "只要我足够穷，就没有什么能够诱惑我。",
    "type": "f",
    "from": "原创",
    "from_who": "陈树凤",
    "creator": "陈树凤",
    "creator_uid": 5678,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591290238",
    "length": 18
  },
  {
    "id": 6241,
    "uuid": "ba136d4c-b6f3-4bd1-a09f-e6fba629c639",
    "hitokoto": "因为和这个人在一起太开心了，所以之后做什么事都只想跟他在一起，这就是爱情。",
    "type": "f",
    "from": "微博",
    "from_who": "一口一个玛丽酥",
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591200592",
    "length": 37
  },
  {
    "id": 6242,
    "uuid": "b425ad6f-e30d-49d6-907f-44d6bd46d9d6",
    "hitokoto": "生活中寻找文艺的过程也是一种文艺。",
    "type": "f",
    "from": "网友",
    "from_who": null,
    "creator": "佩刀写词",
    "creator_uid": 6368,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591161544",
    "length": 17
  },
  {
    "id": 6251,
    "uuid": "2fb44aae-b7c3-4c33-bf5a-cc30cd37c9ad",
    "hitokoto": "你凭什么喜欢我，就凭你眼光好吗？",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "naruto",
    "creator_uid": 6347,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590972937",
    "length": 16
  },
  {
    "id": 6260,
    "uuid": "a60ccdf8-48fa-42af-813d-b59a99f7fab1",
    "hitokoto": "你没有半夜可以陪你打电话的人，你的情绪就像食物，都是靠自己消化的。",
    "type": "f",
    "from": "微博",
    "from_who": null,
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592125861",
    "length": 33
  },
  {
    "id": 6261,
    "uuid": "79304228-88d4-49b5-ab4e-1e08b1a30aa1",
    "hitokoto": "爱才应该是刺中好人的唯一的剑，是恶人能佩上的唯一的花。",
    "type": "f",
    "from": "微博",
    "from_who": null,
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592125733",
    "length": 27
  },
  {
    "id": 6262,
    "uuid": "64265537-b0f0-4aec-9523-ed1a3a26c416",
    "hitokoto": "“不要放手”，他们彼此搂着对方，在令人晕眩的旋转中，化作了记忆的露珠。",
    "type": "f",
    "from": "Bilibili",
    "from_who": "b站用户",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592125312",
    "length": 35
  },
  {
    "id": 6265,
    "uuid": "c3075f89-638c-4ab7-a663-6c9a1cb8faf5",
    "hitokoto": "人类期待某种技术的进步能够颠覆性地改善人类世界，但事实上，新的技术只是反过来再次强调了人类群体原生的缺陷。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592124932",
    "length": 53
  },
  {
    "id": 6270,
    "uuid": "e274f893-119c-4a56-a121-a48b0fa4f588",
    "hitokoto": "生命是什么？生命是一个美好的巧合，是宇宙在奔向熵最大的死寂过程中，为自己创造的观众。",
    "type": "f",
    "from": "网络",
    "from_who": "Declan",
    "creator": "Declan",
    "creator_uid": 6466,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592117482",
    "length": 42
  },
  {
    "id": 6271,
    "uuid": "3f7a075c-8994-4698-81bb-eb4891bff69c",
    "hitokoto": "小时候哭着哭着就笑了，长大后笑着笑着就哭了。",
    "type": "f",
    "from": "网络",
    "from_who": "Declan",
    "creator": "Declan",
    "creator_uid": 6466,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592113511",
    "length": 22
  },
  {
    "id": 6273,
    "uuid": "21491bfc-0d62-4c29-9193-95ab8ec4b9c4",
    "hitokoto": "如果能摸摸我的头的话，我会很高兴的！",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "无脑僵",
    "creator_uid": 6154,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592095570",
    "length": 18
  },
  {
    "id": 6294,
    "uuid": "eb1d6279-b5b6-4a29-9c21-8e861886c676",
    "hitokoto": "世界原本就不是属于你，因此你用不着抛弃，要抛弃的是一切的执著。万物皆为我所用，但非我所属。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "北笙",
    "creator_uid": 6495,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592528673",
    "length": 45
  },
  {
    "id": 6295,
    "uuid": "d8c4c35e-5259-4f9d-ad57-36855a8c8b47",
    "hitokoto": "有些人，你以为可以见面的。有些事，你以为可以一直继续的。然后，也许在你转身的那个刹那。有些人，你就再也见不到了。当太阳落下，又升起来的时候，一切都变了，一不小心就在也回不去了。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "北笙",
    "creator_uid": 6495,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592529196",
    "length": 88
  },
  {
    "id": 6296,
    "uuid": "71f6afe9-a87b-4ed6-a58a-c6f1a73bcfa6",
    "hitokoto": "那你知道洛杉矶凌晨4点的样子吗？满天星星，寥落的灯光，行人很少。",
    "type": "f",
    "from": "科比",
    "from_who": null,
    "creator": "北笙",
    "creator_uid": 6495,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592529551",
    "length": 32
  },
  {
    "id": 6313,
    "uuid": "536f6228-8cac-4cb9-92b6-fe2bb9cc123b",
    "hitokoto": "你大概不知道，我曾那么努力的想在你的世界里存在的久一点，再久一点。",
    "type": "f",
    "from": "网络",
    "from_who": "佚名",
    "creator": "仅此而已",
    "creator_uid": 6533,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592969698",
    "length": 33
  },
  {
    "id": 6340,
    "uuid": "95671922-65a0-4c88-bf5d-18d739ebbe33",
    "hitokoto": "可能，你会为自己剥开一个很酸的橘子而后悔莫及，心中无数次升起丢掉它的念头。可，对橘子来说，你就是它的全世界，你即是它的一切……",
    "type": "f",
    "from": "来自网络",
    "from_who": null,
    "creator": "HuiGuo",
    "creator_uid": 6591,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593435292",
    "length": 63
  },
  {
    "id": 6356,
    "uuid": "545197b1-06da-4ef5-9efe-d430f0debae6",
    "hitokoto": "行走于苍穹之上，将星空献给你。",
    "type": "f",
    "from": "scp-cn-027",
    "from_who": "囚星蝶",
    "creator": "「❦」",
    "creator_uid": 3191,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593860852",
    "length": 15
  },
  {
    "id": 6357,
    "uuid": "53fa91b2-46e6-48b8-8044-3d86f806df99",
    "hitokoto": "不恋尘世浮华，不写红尘纷扰，不叹世道苍凉，不惹情思哀怨；闲看花开，静待花落，冷暖自知，干净如始。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "阁主博客",
    "creator_uid": 2831,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593865427",
    "length": 48
  },
  {
    "id": 6358,
    "uuid": "c57ae5c8-b1ca-4025-af73-0e884ee1660e",
    "hitokoto": "一举一动，都是承诺，会被另一个人看在眼里，记在心上的。",
    "type": "f",
    "from": "网络",
    "from_who": "佚名",
    "creator": "阁主博客",
    "creator_uid": 2831,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593875861",
    "length": 27
  },
  {
    "id": 6368,
    "uuid": "90948bf0-03cd-4c09-a8cd-4fc6d9b8d9c1",
    "hitokoto": "远方未必远，未来一定来。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "像风",
    "creator_uid": 6731,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1594981252",
    "length": 12
  },
  {
    "id": 6369,
    "uuid": "c92e2e2c-393f-4fad-b318-f4ae1e59faee",
    "hitokoto": "世界美好与莫环环相扣。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "提莫",
    "creator_uid": 6194,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1594971124",
    "length": 11
  },
  {
    "id": 6374,
    "uuid": "ffda9c51-3d72-48ee-8173-712fd6247d15",
    "hitokoto": "见到你那一刻我心里有场海啸，可我静静站着，没有让任何人知道。",
    "type": "f",
    "from": "网络",
    "from_who": "佚名",
    "creator": "Rocco",
    "creator_uid": 6694,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1594609988",
    "length": 30
  },
  {
    "id": 6383,
    "uuid": "2dcab3b6-3e87-452a-bbed-ab1dd8b04b52",
    "hitokoto": "你没有舍不得，我也不好意思难过。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Ada",
    "creator_uid": 6698,
    "reviewer": 6,
    "commit_from": "web",
    "created_at": "1595148435",
    "length": 16
  },
  {
    "id": 6412,
    "uuid": "648b1517-749b-4045-b4e3-561f472ca2ea",
    "hitokoto": "我喜欢草莓，草莓蛋糕不行，草莓软糖不行，只有草莓才行。就像我喜欢你，长得像你不行，性格像你不行，只有你才行。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "麻吉酷博异",
    "creator_uid": 6796,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1595666281",
    "length": 54
  },
  {
    "id": 6421,
    "uuid": "d0513cdc-f304-4c36-bede-5f5a6b479692",
    "hitokoto": "有些父母宁愿相信不真实的营销号，也不愿意相信自己的孩子。",
    "type": "f",
    "from": "Bilibili",
    "from_who": "滑稽的游侠",
    "creator": "wujiuqier",
    "creator_uid": 6858,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1596266893",
    "length": 28
  },
  {
    "id": 6422,
    "uuid": "bb74eb6c-884f-45f8-be0c-cddc37d02f20",
    "hitokoto": "若他仍在世，现在可能会尝试做不同的音乐，发掘新人，不过我们个性一样，会去挑战自己。",
    "type": "f",
    "from": "网络",
    "from_who": "张惠妹",
    "creator": "PaulWong",
    "creator_uid": 6535,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1596122132",
    "length": 41
  },
  {
    "id": 6447,
    "uuid": "c25e9abf-07ff-4f63-b6eb-7e76c2c6b930",
    "hitokoto": "要把所有的夜归还给星河，把所有的春光归还给疏疏篱落，把所有的慵慵沉迷与不前，归还给过去的我。明日之我，胸中有丘壑，立马振山河。",
    "type": "f",
    "from": "德卡先生的信箱",
    "from_who": null,
    "creator": "顾及",
    "creator_uid": 6897,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1596905736",
    "length": 63
  },
  {
    "id": 6464,
    "uuid": "c7a160e5-9ec5-479b-9657-d0c735cb4348",
    "hitokoto": "听都没听说过的事，假装听懂、明白是一件很失礼的事情。",
    "type": "f",
    "from": "令人心动的offer",
    "from_who": "金律",
    "creator": "小何花",
    "creator_uid": 7319,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1601626551",
    "length": 26
  },
  {
    "id": 6465,
    "uuid": "4941af7f-a4f4-485b-aac3-602e9b5dedb0",
    "hitokoto": "世上本没有什么岁月静好，只是有人为你负重前行。",
    "type": "f",
    "from": "网络",
    "from_who": "网友",
    "creator": "柒染",
    "creator_uid": 7324,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1601639420",
    "length": 23
  },
  {
    "id": 6512,
    "uuid": "8d68d01f-8ca6-4ade-b1f2-8caafa08390a",
    "hitokoto": "这个社会歧视女性，也歧视男性。本质上来说，这个世界歧视弱者。",
    "type": "f",
    "from": "硬核的半佛仙人",
    "from_who": "硬核的半佛仙人",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598057124",
    "length": 30
  },
  {
    "id": 6539,
    "uuid": "ecd33522-b001-44a2-97c2-8d010d47c79a",
    "hitokoto": "一见如故，生万千欢喜心。",
    "type": "f",
    "from": "网络",
    "from_who": "网络",
    "creator": "见你时澜青，不见时生春",
    "creator_uid": 7133,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599382672",
    "length": 12
  },
  {
    "id": 6549,
    "uuid": "3cdf95f2-7911-41e4-b9a6-e6b667ca62ca",
    "hitokoto": "逆着光行走，任风吹雨打。",
    "type": "f",
    "from": "起风了",
    "from_who": "买辣椒也用券",
    "creator": "lteyox",
    "creator_uid": 7087,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598698466",
    "length": 12
  },
  {
    "id": 6602,
    "uuid": "968efb3a-3f96-45c3-b57e-a93d89fd9d59",
    "hitokoto": "其实结束并不是真正的结束，而是美好的开始。",
    "type": "f",
    "from": "bilibili",
    "from_who": "1sdaxf",
    "creator": "1sdaxf",
    "creator_uid": 7504,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1603369466",
    "length": 21
  },
  {
    "id": 6603,
    "uuid": "b8bbc457-d6f3-4fed-be62-09bb81cbaa8b",
    "hitokoto": "不是天才，就要慎独。",
    "type": "f",
    "from": "网络",
    "from_who": "皎月半洒花",
    "creator": "s1c",
    "creator_uid": 7386,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1603328317",
    "length": 10
  },
  {
    "id": 6703,
    "uuid": "f6c80eb2-f6e7-438d-8752-f6a94db8d2f5",
    "hitokoto": "不求闻达，但求心安。",
    "type": "f",
    "from": "网络",
    "from_who": "增增",
    "creator": "拉巴",
    "creator_uid": 7689,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604894784",
    "length": 10
  },
  {
    "id": 6707,
    "uuid": "2488e60c-8216-44d9-a465-abf198665bf4",
    "hitokoto": "长大了，就要自己做决定，哪怕是艰难的决定。",
    "type": "f",
    "from": "bilibili",
    "from_who": "老番茄",
    "creator": "Eason.J",
    "creator_uid": 7702,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605008905",
    "length": 21
  },
  {
    "id": 6724,
    "uuid": "c06bec38-878f-4c5e-9e1d-2838e96c7a02",
    "hitokoto": "卫星轨道千万条，心心相印才永久。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Gilleece",
    "creator_uid": 7474,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605362897",
    "length": 16
  },
  {
    "id": 6850,
    "uuid": "48be1605-7ccd-4e1e-802b-7d3c017312f2",
    "hitokoto": "我们最终都要远行，最终都要跟稚嫩的自己告别。",
    "type": "f",
    "from": "佚名",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219984",
    "length": 22
  },
  {
    "id": 6878,
    "uuid": "58794c18-fe72-45dc-9758-8c6c65ffc5cb",
    "hitokoto": "泡夜店，纹身，打洞，买醉……这些事看似很酷，其实这些事一点难度都没有，只要你愿意去做就能做到。更酷的事情应该是那些不容易做到的事，比如看书，健身，赚钱，用心爱一个人，这种在常人看来无趣且难以坚持的事情。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266681",
    "length": 101
  },
  {
    "id": 6889,
    "uuid": "7780b261-2d65-4f04-b377-9bd927de737f",
    "hitokoto": "我这个人虐点特别奇怪：不怕死不怕残，但我怕看见诚实的人被迫说谎；正直的人被迫弯腰；痴情的人变得薄情冷漠；直言者被迫噤声；理想主义者亲眼见到理想破碎。谎话连篇者最后的一句真话；奴颜婢膝者最后挺直了腰杆；缄口自保者突然仗义执言；曾遭理想背叛的人最后选择为理想而死。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266888",
    "length": 130
  },
  {
    "id": 6891,
    "uuid": "a605995c-f797-41e1-a018-c0018bf648b8",
    "hitokoto": "无人与我立黄昏，无人问我粥可温。 无人与我捻熄灯，无人共我书半生。 无人陪我夜已深，无人与我把酒分。 无人拭我相思痕，无人梦我与前尘。 无人陪我顾星辰，无人醒我茶已冷。 无人听我述衷诚，无人解我心头梦。 无人伴我聆此声，无人愁我独行程。 回首向来萧瑟处，无人等在灯火阑珊处。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266912",
    "length": 137
  },
  {
    "id": 6892,
    "uuid": "c98ba94f-324d-4819-88f7-7233ac1c5e65",
    "hitokoto": "我所有的自负皆来自我的自卑，所有的英雄气概都来自于我的软弱。嘴里振振有词是因为心里满是怀疑，深情是因为痛恨自己无情。这世界没有一件事情是虚空而生的，站在光里，背后就会有阴影，这深夜里一片寂静，是因为你还没有听见声音。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266959",
    "length": 108
  },
  {
    "id": 6896,
    "uuid": "61e5bc93-375d-43e6-b21d-85fdb38cb219",
    "hitokoto": "一个人在沙漠的机场，等一艘开往亚特兰蒂斯的船。",
    "type": "f",
    "from": "佚名",
    "from_who": null,
    "creator": "Taylor",
    "creator_uid": 7972,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607561778",
    "length": 23
  },
  {
    "id": 6897,
    "uuid": "1dab73c8-0aa1-412a-8a97-6322e3e88635",
    "hitokoto": "“不去努力然后告诉自己我根本就不想要”的痛苦，比“拼命努力后失败”的痛苦，要小得多。",
    "type": "f",
    "from": "未知",
    "from_who": "匿名",
    "creator": "Taylor",
    "creator_uid": 7972,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607564925",
    "length": 42
  },
  {
    "id": 6905,
    "uuid": "410177d0-e4da-4753-8dea-c9336b69fb78",
    "hitokoto": "你可不是什么普通女孩，你是我的女孩。",
    "type": "f",
    "from": "贴吧",
    "from_who": null,
    "creator": "lzh",
    "creator_uid": 8015,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1608009973",
    "length": 18
  },
  {
    "id": 6908,
    "uuid": "3b043fb9-11d1-4cb2-8356-0c7f66aa6458",
    "hitokoto": "我生来就是高山而非溪流，我欲于群峰之巅俯视平庸的沟壑。我本来就是人杰而非草芥，我站在伟人之间藐视卑微的懦夫。",
    "type": "f",
    "from": "云南华坪坝女高校训",
    "from_who": "张桂梅",
    "creator": "起名废",
    "creator_uid": 7979,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1608363601",
    "length": 54
  },
  {
    "id": 6915,
    "uuid": "86f3c9f4-f6f1-4054-988f-f14bdfcd9f7c",
    "hitokoto": "不要眼睛一红，就觉得人间不值得了，散伙乃是人间常态，你我哪能例外。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1608438837",
    "length": 33
  },
  {
    "id": 6944,
    "uuid": "fb8d7e63-8bd3-4a67-8f5d-fa5c59945a5a",
    "hitokoto": "从来就没有什么失败的人，只有半途而废的人。",
    "type": "f",
    "from": "锤子科技发布会",
    "from_who": "罗永浩",
    "creator": "菊花丶一紧",
    "creator_uid": 8280,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611112001",
    "length": 21
  },
  {
    "id": 6946,
    "uuid": "03c9c019-c546-448a-8921-e18dbf8c930f",
    "hitokoto": "爵士乐响起之时便是吉翁覆灭之日！",
    "type": "f",
    "from": "机动战士高达雷霆宙域",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611229400",
    "length": 16
  },
  {
    "id": 6967,
    "uuid": "8cf943da-62ed-4b2f-8da5-eb9a0ac92fac",
    "hitokoto": "明知道这颗种子不会发芽，却依然每天盼望它能长大。",
    "type": "f",
    "from": "网络",
    "from_who": "佚名",
    "creator": "青医.",
    "creator_uid": 8323,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611562228",
    "length": 24
  },
  {
    "id": 6977,
    "uuid": "807d8467-8d59-4ac0-aac6-46caef96251e",
    "hitokoto": "我劝这两个年轻人耗子尾汁，好好反思，以后不要再犯这样的聪明，小聪明啊！",
    "type": "f",
    "from": "马老师视频",
    "from_who": "马保国",
    "creator": "ChRshichi",
    "creator_uid": 8336,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611710227",
    "length": 35
  },
  {
    "id": 6983,
    "uuid": "eb65cb76-b24c-4373-a366-2f4112a28318",
    "hitokoto": "予力众生，成就不凡。",
    "type": "f",
    "from": "Microsoft",
    "from_who": null,
    "creator": "MinatoXeon",
    "creator_uid": 8352,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611757666",
    "length": 10
  },
  {
    "id": 7064,
    "uuid": "862ae932-ee96-4920-b66c-cf4e42be3040",
    "hitokoto": "生命的遗产是对知识的更新。",
    "type": "f",
    "from": "B站 知乎 用户YJango",
    "from_who": "YJango",
    "creator": "saicem",
    "creator_uid": 8559,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613889298",
    "length": 13
  },
  {
    "id": 7075,
    "uuid": "a3045c3a-ac0a-4598-8e79-8403ec3a9727",
    "hitokoto": "我已经很乖了，自己把全部的委屈和心酸都宣泄在黑夜里。",
    "type": "f",
    "from": "网易云",
    "from_who": "网络作者",
    "creator": "eqvpkbz",
    "creator_uid": 5492,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1614068423",
    "length": 26
  },
  {
    "id": 7102,
    "uuid": "47bab181-2d70-46df-ab37-cc0c83a7b070",
    "hitokoto": "I'm still asking you to believe - not in my ability to bring about change, but in yours. I believe in change because I believe in you.",
    "type": "f",
    "from": "Twitter",
    "from_who": "美国第44任总统 Barack Hussein Obama",
    "creator": "roco",
    "creator_uid": 8685,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1616333212",
    "length": 134
  },
  {
    "id": 7136,
    "uuid": "35f1a684-f3f4-4db2-859b-ade91fa74559",
    "hitokoto": "莫要在诗中迷茫。又何必孤自彷徨。你为黑夜点亮一盏灯，黑夜会为你绽放漫天星光。",
    "type": "f",
    "from": "回声",
    "from_who": "刘渤源",
    "creator": "负雨",
    "creator_uid": 6885,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614147485",
    "length": 38
  },
  {
    "id": 7137,
    "uuid": "1f0e847c-d986-4a7f-8633-0a04c6fba970",
    "hitokoto": "赏一朵野花，何必嗅到沁人的花香。扔一块石子，又何必知晓大海的深邃。",
    "type": "f",
    "from": "回声",
    "from_who": "刘渤源",
    "creator": "负雨",
    "creator_uid": 6885,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614147650",
    "length": 33
  },
  {
    "id": 7138,
    "uuid": "fe98706f-dd3a-4dc6-b748-9b8cd5b0404c",
    "hitokoto": "快步行过的小路旁，青草开得正旺。莫要只是追逐梦想，而错过温情，与花香。",
    "type": "f",
    "from": "轻驻",
    "from_who": "刘渤源",
    "creator": "负雨",
    "creator_uid": 6885,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614147701",
    "length": 35
  },
  {
    "id": 7156,
    "uuid": "d37887fb-4820-4f4e-9984-1cb08cd82c05",
    "hitokoto": "往事真的不堪回首吗？",
    "type": "f",
    "from": "Ajiang's Blog",
    "from_who": "Ajiang",
    "creator": "Ajiang",
    "creator_uid": 7057,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614410005",
    "length": 10
  },
  {
    "id": 7167,
    "uuid": "4f57c3f0-c12b-4257-bf7a-ba8503b34b01",
    "hitokoto": "你得到什么东西，必然就会失去什么东西。如果你觉得你什么都没有失去，那可能仅仅是你觉得。",
    "type": "f",
    "from": "studyMachine",
    "from_who": "studyMachine",
    "creator": "macstu",
    "creator_uid": 8660,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614917570",
    "length": 43
  },
  {
    "id": 7182,
    "uuid": "2175e308-f4f3-4040-b56f-eca179f4d77d",
    "hitokoto": "原是今生今世已惘然，山河岁月空惆怅，而我，终将是要等着你的。",
    "type": "f",
    "from": "网络",
    "from_who": "胡兰成",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615030940",
    "length": 30
  },
  {
    "id": 7218,
    "uuid": "1ba47b8a-3286-420d-a0a7-e03a683838f7",
    "hitokoto": "乐观主义和悲观主义对世界都有贡献，前者发明了飞机，后者发明了降落伞。",
    "type": "f",
    "from": "未知",
    "from_who": "未知",
    "creator": "leeao82",
    "creator_uid": 8713,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617084937",
    "length": 34
  },
  {
    "id": 7330,
    "uuid": "bda58fe9-16b6-4898-b61c-51317cd65117",
    "hitokoto": "人总要抱紧什么才知道自己真的存在，哪怕那只是幻影。",
    "type": "f",
    "from": "网络",
    "from_who": "不知",
    "creator": "凉墨",
    "creator_uid": 9409,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1622269040",
    "length": 25
  },
  {
    "id": 7334,
    "uuid": "03372c85-7222-4f01-a211-2d74a0744ffb",
    "hitokoto": "我命由我不由天，吴钩弯，展锋寒。",
    "type": "f",
    "from": "原创",
    "from_who": "一高三学子",
    "creator": "relativity",
    "creator_uid": 9353,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1621738612",
    "length": 16
  },
  {
    "id": 7335,
    "uuid": "550ec167-51a5-4205-87dd-f7a910d4f9cc",
    "hitokoto": "当我们熟悉的一个个名字相继离开时，我们便知道，时代的接力棒就要到我们手上了。",
    "type": "f",
    "from": "b站评论",
    "from_who": null,
    "creator": "relativity",
    "creator_uid": 9353,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1621738901",
    "length": 38
  },
  {
    "id": 7338,
    "uuid": "75a45fd4-4f2f-45eb-80cb-6f0a7bcdfaf2",
    "hitokoto": "用代码表达言语的魅力，用代码书写山河的壮丽。",
    "type": "f",
    "from": "一言开发者中心",
    "from_who": "一言",
    "creator": "DreamOne",
    "creator_uid": 9209,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1621833280",
    "length": 22
  },
  {
    "id": 7341,
    "uuid": "93829d19-f6b3-4ecd-a223-90702eeeec5c",
    "hitokoto": "人生有那么一首诗，往往是当你拥有它的时候，你没有读懂它。而当你读懂它时，它已经离你远去了，而这首诗就叫青春。",
    "type": "f",
    "from": "网络",
    "from_who": null,
    "creator": "凉墨",
    "creator_uid": 9409,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1622268971",
    "length": 54
  },
  {
    "id": 7363,
    "uuid": "0fd57b5c-cce4-41ed-94e4-b6a76bf0e5d5",
    "hitokoto": "记忆是掌心的水，不论你摊开还是握紧，终究还是会从指缝中一滴一滴流淌干净。只是，那水的凉意，却是可以让人始终无法忘记！",
    "type": "f",
    "from": "仙逆",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1625303483",
    "length": 58
  },
  {
    "id": 7364,
    "uuid": "efedcfa7-8fad-4fc2-ae88-f15ba32a9526",
    "hitokoto": "这雨生于天，死于地，中间的过程就是人生。",
    "type": "f",
    "from": "仙逆",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1625303511",
    "length": 20
  },
  {
    "id": 7365,
    "uuid": "afe8e8c0-547c-4b46-851d-b6b156c2f4d6",
    "hitokoto": "爱情就像一条河，左岸是明灭千年的欢笑，右岸是烛光下永恒的沉默，中间流淌的，是年年岁岁淡淡的寂寞。",
    "type": "f",
    "from": "仙逆",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1625303565",
    "length": 48
  },
  {
    "id": 7366,
    "uuid": "8b9e4609-b377-4789-8ac9-847b5b8e13be",
    "hitokoto": "人亡则死，心亡则忘。",
    "type": "f",
    "from": "仙逆",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1625303606",
    "length": 10
  },
  {
    "id": 7370,
    "uuid": "9b1da76b-c8d7-4d79-be68-7da3d7206b77",
    "hitokoto": "你曾打马过银河，倒影一百光年长。",
    "type": "f",
    "from": "微博",
    "from_who": "李倦容",
    "creator": "姜堰",
    "creator_uid": 9562,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1624425510",
    "length": 16
  },
  {
    "id": 7373,
    "uuid": "c436b0ce-7d8a-4f71-8db8-5e9532d89b12",
    "hitokoto": "贫瘠的土地上,长不出和平的大树;连天的烽火中,结不出发展的硕果。",
    "type": "f",
    "from": "亚洲相互协作与信任措施会议第四次峰会",
    "from_who": "习近平",
    "creator": "席霖",
    "creator_uid": 9559,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1624463819",
    "length": 32
  },
  {
    "id": 7374,
    "uuid": "0f212f09-9345-4b02-a7e9-7cc22c1684ae",
    "hitokoto": "总是在失去后，才会想再拥有，总是在离别中，才想在回头。",
    "type": "f",
    "from": "仙逆",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1625304172",
    "length": 27
  },
  {
    "id": 7399,
    "uuid": "12086471-46b0-420d-9ae4-4fff1b835ec0",
    "hitokoto": "少几分执着，多一些洒脱。",
    "type": "f",
    "from": "求魔",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1625306194",
    "length": 12
  },
  {
    "id": 7400,
    "uuid": "16c44d67-0350-4994-a57b-4151d31fff1c",
    "hitokoto": "我眼中的世界，你们看不到。",
    "type": "f",
    "from": "求魔",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1625305917",
    "length": 13
  },
  {
    "id": 7401,
    "uuid": "6dccdbb2-1e95-44b0-984b-2f5601e19aea",
    "hitokoto": "无次数的沉沦就是为了苏醒。",
    "type": "f",
    "from": "求魔",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1625305961",
    "length": 13
  },
  {
    "id": 7402,
    "uuid": "7aa18f23-15c5-4bef-98b5-22cac575625f",
    "hitokoto": "花草落地生根，它有选择么？",
    "type": "f",
    "from": "求魔",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1625305904",
    "length": 13
  },
  {
    "id": 7403,
    "uuid": "f42a1c7d-f934-4415-a62a-0dff4e87049b",
    "hitokoto": "一切真实与虚假，一切辉煌与破灭，只存后人之言，只存岁月之中。",
    "type": "f",
    "from": "求魔",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1625306029",
    "length": 30
  },
  {
    "id": 7405,
    "uuid": "c6e27dd7-5d5d-48ce-ba8d-a4a28c678830",
    "hitokoto": "一如软件深似海，头发从此是路人！",
    "type": "f",
    "from": "码农",
    "from_who": "来自网络",
    "creator": "dgm",
    "creator_uid": 9605,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1625120462",
    "length": 16
  },
  {
    "id": 7406,
    "uuid": "3fea6809-516d-497f-9221-1b7d61f29e27",
    "hitokoto": "我左手是修魔海短暂的因果，右手里百年一个漫长的孤陌。",
    "type": "f",
    "from": "仙逆",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1625303694",
    "length": 26
  },
  {
    "id": 7407,
    "uuid": "1eaa75cc-18d5-432c-add3-09f0eb34d238",
    "hitokoto": "无法避过轮回，而岁月亦没有等我，你，何时来带我。",
    "type": "f",
    "from": "仙逆",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1625303782",
    "length": 24
  },
  {
    "id": 7408,
    "uuid": "71f0481f-f6eb-41e5-975c-d0c82fb3ec1e",
    "hitokoto": "闻道者，朝生夕死，足尔；寻道者，忘生之死，憾尔。",
    "type": "f",
    "from": "仙逆",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1625303817",
    "length": 24
  },
  {
    "id": 7409,
    "uuid": "ad1c0589-f957-48ee-a765-3f034eb1d91d",
    "hitokoto": "生为人杰，死亦鬼雄，我辈修士，何惜一战！",
    "type": "f",
    "from": "仙逆",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1625303840",
    "length": 20
  },
  {
    "id": 7410,
    "uuid": "ea27ce3d-cfe6-47f9-9e3d-96b939400a92",
    "hitokoto": "此生的约定，白头亦不负。",
    "type": "f",
    "from": "求魔",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1625305847",
    "length": 12
  },
  {
    "id": 7411,
    "uuid": "fbbdb9fb-b99b-4a3f-be95-9db4ce7be9d6",
    "hitokoto": "那些曾经相识依稀还在，却在风云变幻年轮中，如尘埃落江，寻已无痕。",
    "type": "f",
    "from": "求魔",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1625305718",
    "length": 32
  },
  {
    "id": 7412,
    "uuid": "a1197e25-3193-4e77-b15c-3f0df601bebb",
    "hitokoto": "如果这天地间的世人皆醉，而你独醒，则等于是世人皆醒你独眠。",
    "type": "f",
    "from": "求魔",
    "from_who": "耳根",
    "creator": "余空",
    "creator_uid": 9621,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1625305693",
    "length": 29
  },
  {
    "id": 7414,
    "uuid": "b5bef0ec-2be8-47b2-aee9-f6368d3f3ab9",
    "hitokoto": "满堂花醉三千客，一剑霜寒十四州。",
    "type": "f",
    "from": "我只想安兴休仙",
    "from_who": "奥藤蔓",
    "creator": "富婆挚友",
    "creator_uid": 9677,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1625827679",
    "length": 16
  },
  {
    "id": 7423,
    "uuid": "fd8b0081-62d8-4ac5-82d8-044c773d8a13",
    "hitokoto": "背影要显得很高大，才够真实的自己躲在自己的阴影下。",
    "type": "f",
    "from": "弱智吧",
    "from_who": "名字平均值就好",
    "creator": "azmatter",
    "creator_uid": 8944,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1617817139",
    "length": 25
  },
  {
    "id": 7459,
    "uuid": "d05cf3ac-b10a-4dc6-b1c2-6555d14f82a7",
    "hitokoto": "我们执着于寻找对方缺少的品质，真是太傻了。",
    "type": "f",
    "from": "面纱",
    "from_who": null,
    "creator": "LINGCX",
    "creator_uid": 9883,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627226871",
    "length": 21
  },
  {
    "id": 7466,
    "uuid": "ee292874-0df7-4e1e-8d30-9e86b105a5d8",
    "hitokoto": "恋爱是为了开心，选择不爱也是。",
    "type": "f",
    "from": "《佚名者录》",
    "from_who": "佚名",
    "creator": "鹤空流乂",
    "creator_uid": 9962,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627911855",
    "length": 15
  },
  {
    "id": 7489,
    "uuid": "1046112d-8b76-40d3-8634-df76dce8f290",
    "hitokoto": "少年与爱永不老去，即便披荆斩棘，丢失怒马鲜衣。",
    "type": "f",
    "from": "莫峻",
    "from_who": null,
    "creator": "Morning Dew",
    "creator_uid": 9775,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629181491",
    "length": 23
  },
  {
    "id": 7500,
    "uuid": "37ef0e57-2dab-4f3f-be86-910d0d772668",
    "hitokoto": "我们总喜欢拿顺其自然来敷衍人生路上的荆棘坎坷，却很少承认，真正的顺其自然是竭尽所能之后的不强求，而非两手一摊的不作为。",
    "type": "f",
    "from": "恋练有词",
    "from_who": "朱伟",
    "creator": "kiko",
    "creator_uid": 10187,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629675651",
    "length": 59
  },
  {
    "id": 7503,
    "uuid": "ca9040c4-aa16-4ed7-90fb-614a7e5f9c14",
    "hitokoto": "没有任何力量能毁了下一代，除了不懂时代的上一代。",
    "type": "f",
    "from": "网络",
    "from_who": "佚名",
    "creator": "小行星坠落",
    "creator_uid": 10228,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1630034795",
    "length": 24
  }
]